import * as e from "react";
import { useState as y, useRef as F, useCallback as G, useEffect as K, Fragment as Ht, forwardRef as En, useMemo as Ne, useLayoutEffect as Ut, Component as Yt, Children as wt, isValidElement as yn, cloneElement as gn, createContext as vn, useContext as kn, createRef as Nn } from "react";
import { createPortal as wn } from "react-dom";
const F_ = {
  primary: "#1d4ed8",
  primaryBg: "#dbeafe",
  headerBg: "#1f2937",
  text: "#374151",
  textMuted: "#6b7280",
  border: "#e5e7eb",
  surface: "#f3f4f6"
}, ht = "poc_portal_token", Je = "poc_portal_refresh", ut = "auth:session-expired", Vt = window.location.hostname === "dev.gennolab.co.jp" ? "" : "https://dev.gennolab.co.jp";
let Jt = Vt + "/chat-api/api/auth";
function M_(t) {
  t.authBase && (Jt = t.authBase);
}
function Et(t) {
  try {
    const n = t.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(decodeURIComponent(escape(atob(n))));
  } catch {
    return {};
  }
}
function $n(t, n = 30) {
  const a = Et(t).exp;
  return !a || a * 1e3 < Date.now() + n * 1e3;
}
function Zt(t = 30) {
  const n = localStorage.getItem(Je);
  if (!n) return !0;
  const a = Et(n).exp;
  return !!a && a * 1e3 < Date.now() + t * 1e3;
}
function xn() {
  return localStorage.getItem(ht);
}
function Cn(t, n) {
  localStorage.setItem(ht, t), n && localStorage.setItem(Je, n);
}
function Bn() {
  localStorage.removeItem(ht), localStorage.removeItem(Je), Qt();
}
function Ke() {
  Bn(), window.dispatchEvent(new Event(ut));
}
function D_(t) {
  return window.addEventListener(ut, t), () => window.removeEventListener(ut, t);
}
let He = null;
const Sn = 2147483647;
function Ln() {
  if (Qt(), Zt()) {
    Ke();
    return;
  }
  const t = localStorage.getItem(Je), n = t ? Et(t).exp : void 0;
  if (!n) return;
  const a = Math.min(Math.max(n * 1e3 - Date.now() - 30 * 1e3, 0), Sn);
  He = setTimeout(() => {
    He = null, Ln();
  }, a);
}
function Qt() {
  He !== null && (clearTimeout(He), He = null);
}
let at = null;
function en() {
  return at || (at = An()), at;
}
async function An() {
  try {
    return await jn();
  } finally {
    at = null;
  }
}
async function jn() {
  const t = localStorage.getItem(Je);
  if (!t)
    return Ke(), null;
  let n;
  try {
    n = await fetch(Jt + "/refresh", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refreshToken: t })
    });
  } catch {
    return null;
  }
  if (!n.ok)
    return n.status < 500 && Ke(), null;
  const a = await n.json().catch(() => ({}));
  return a.access_token ? (Cn(a.access_token, a.refresh_token), a.access_token) : (Ke(), null);
}
async function Fn() {
  if (Zt())
    return Ke(), null;
  const t = xn();
  return t && !$n(t) ? t : en();
}
async function Ze(t, n = {}) {
  const a = (l) => {
    var s;
    return {
      ...n,
      headers: { ...(s = n.headers) != null ? s : {}, ...l ? { Authorization: "Bearer " + l } : {} }
    };
  }, o = await Fn();
  let r = await fetch(t, a(o));
  if (r.status === 401 && o) {
    const l = await en();
    l && (r = await fetch(t, a(l)));
  }
  return r;
}
let Te = Vt + "/chat-api/api/comments";
function I_(t) {
  t.base && (Te = t.base);
}
function Mn(t) {
  return t.parentId !== void 0 && t.parentId !== null;
}
async function Qe(t) {
  var a;
  const n = await t.json().catch(() => ({}));
  if (!t.ok) throw new Error((a = n.error) != null ? a : `요청 실패 (${t.status})`);
  return n;
}
async function $t(t, n, a, o, r) {
  const l = new URLSearchParams({ targetType: t, targetId: n, page: String(a), size: String(o) }), s = await Ze(`${Te}?${l}`, { cache: "no-store", signal: r });
  return Qe(s);
}
async function Dn(t, n, a, o) {
  const r = await Ze(Te, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ targetType: t, targetId: n, content: a, parentId: o })
  });
  return Qe(r);
}
async function In(t, n) {
  const a = await Ze(`${Te}/${t}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ content: n })
  });
  return Qe(a);
}
async function Rn(t) {
  const n = await Ze(`${Te}/${t}`, { method: "DELETE" });
  return (await Qe(n)).status;
}
async function Tn(t, n, a) {
  if (n.length === 0) return {};
  const o = new URLSearchParams({ targetType: t, targetIds: n.join(",") }), r = await Ze(`${Te}/counts?${o}`, { cache: "no-store", signal: a });
  return (await Qe(r)).counts;
}
const xt = 50;
function mt(t) {
  return t.parentId === void 0 || t.parentId === null;
}
function qn(t, n) {
  if (mt(n)) return [...t, n];
  const a = n.parentId;
  let o = -1;
  for (let r = 0; r < t.length; r += 1)
    (t[r].id === a || t[r].parentId === a) && (o = r);
  return o < 0 ? [...t, n] : [...t.slice(0, o + 1), n, ...t.slice(o + 1)];
}
function qe(t, n) {
  return t instanceof Error && t.message ? t.message : n;
}
function zn(t, n) {
  const [a, o] = y([]), [r, l] = y(!0), [s, c] = y(!0), [i, u] = y(null), [d, _] = y(0), [p, b] = y(0), f = t + " " + n, m = F(f);
  m.current = f;
  const [h, v] = y(0), w = G(() => v((C) => C + 1), []);
  K(() => {
    const C = new AbortController(), L = f;
    return o([]), b(0), _(0), u(null), l(!0), c(!0), $t(t, n, 0, xt, C.signal).then((j) => {
      m.current === L && (o(j.items), _(j.total));
    }).catch((j) => {
      C.signal.aborted || m.current !== L || u(qe(j, "댓글을 불러오지 못했어요."));
    }).finally(() => {
      m.current === L && (l(!1), c(!1));
    }), () => C.abort();
  }, [t, n, f, h]);
  const N = a.filter(mt).length < d, $ = G(() => {
    if (r || !N) return;
    const C = p + 1, L = m.current;
    l(!0), $t(t, n, C, xt).then((j) => {
      m.current === L && (o((q) => [...q, ...j.items]), _(j.total), b(C));
    }).catch((j) => {
      m.current === L && u(qe(j, "댓글을 더 불러오지 못했어요."));
    }).finally(() => {
      m.current === L && l(!1);
    });
  }, [r, N, p, t, n]), k = G(async (C, L) => {
    const j = C.trim();
    if (!j) return !1;
    const q = -Date.now(), R = {
      id: q,
      targetType: t,
      targetId: n,
      parentId: L != null ? L : null,
      authorName: "나",
      content: j,
      createdAt: (/* @__PURE__ */ new Date()).toISOString(),
      deleted: !1,
      mine: !0,
      pending: !0
    }, A = m.current;
    o((z) => qn(z, R)), u(null);
    try {
      const z = await Dn(t, n, j, L);
      return m.current !== A || (o((H) => H.map((D) => D.id === q ? z : D)), L === void 0 && _((H) => H + 1)), !0;
    } catch (z) {
      return m.current !== A || (o((H) => H.filter((D) => D.id !== q)), u(qe(z, "댓글을 등록하지 못했어요."))), !1;
    }
  }, [t, n]), x = G(async (C, L) => {
    const j = L.trim();
    if (!j) return !1;
    const q = m.current;
    try {
      const R = await In(C, j);
      return m.current !== q || o((A) => A.map((z) => z.id === C ? R : z)), !0;
    } catch (R) {
      return m.current === q && u(qe(R, "댓글을 수정하지 못했어요.")), !1;
    }
  }, []), I = G(async (C) => {
    const L = m.current;
    try {
      const j = await Rn(C);
      return m.current !== L ? !0 : j === "soft-deleted" ? (o((q) => q.map((R) => R.id === C ? { ...R, deleted: !0, mine: !1, content: void 0, authorName: void 0 } : R)), !0) : (o((q) => {
        const R = q.find((D) => D.id === C), A = q.filter((D) => D.id !== C);
        if (!R) return A;
        if (mt(R))
          return _((D) => Math.max(0, D - 1)), A;
        const z = R.parentId, H = A.find((D) => D.id === z);
        return H && H.deleted && !A.some((D) => D.parentId === z) ? (_((D) => Math.max(0, D - 1)), A.filter((D) => D.id !== z)) : A;
      }), !0);
    } catch (j) {
      return m.current === L && u(qe(j, "댓글을 삭제하지 못했어요.")), !1;
    }
  }, []);
  return {
    items: a,
    loading: r,
    initialLoading: s,
    error: i,
    count: a.filter((C) => !C.deleted).length,
    hasMore: N,
    loadMore: $,
    reload: w,
    add: k,
    edit: x,
    remove: I
  };
}
const Pn = "_thread_1layy_9", Xn = "_head_1layy_28", On = "_headTitle_1layy_37", Wn = "_headCount_1layy_43", Gn = "_list_1layy_54", Kn = "_row_1layy_61", Hn = "_isReply_1layy_73", Un = "_pending_1layy_80", Yn = "_avatar_1layy_84", Vn = "_avatarGhost_1layy_98", Jn = "_body_1layy_103", Zn = "_meta_1layy_108", Qn = "_author_1layy_116", ea = "_dept_1layy_122", ta = "_time_1layy_130", na = "_text_1layy_135", aa = "_textDeleted_1layy_143", oa = "_acts_1layy_148", ra = "_act_1layy_148", la = "_actDanger_1layy_169", sa = "_empty_1layy_175", ca = "_error_1layy_182", ia = "_skeleton_1layy_196", ua = "_more_1layy_219", ma = "_foot_1layy_245", da = "_composer_1layy_252", _a = "_composerInput_1layy_261", pa = "_composerActions_1layy_284", fa = "_btn_1layy_291", ba = "_btnPrimary_1layy_301", ha = "_btnGhost_1layy_310", B = {
  thread: Pn,
  head: Xn,
  headTitle: On,
  headCount: Wn,
  list: Gn,
  row: Kn,
  isReply: Hn,
  pending: Un,
  avatar: Yn,
  avatarGhost: Vn,
  body: Jn,
  meta: Zn,
  author: Qn,
  dept: ea,
  time: ta,
  text: na,
  textDeleted: aa,
  acts: oa,
  act: ra,
  actDanger: la,
  empty: sa,
  error: ca,
  skeleton: ia,
  more: ua,
  foot: ma,
  composer: da,
  composerInput: _a,
  composerActions: pa,
  btn: fa,
  btnPrimary: ba,
  btnGhost: ha
}, Ct = ["#3B82F6", "#7C3AED", "#10B981", "#F97316", "#EF4444", "#0EA5E9"];
function Ea(t) {
  let n = 0;
  for (let a = 0; a < t.length; a += 1) n = (n * 31 + t.charCodeAt(a)) % 997;
  return Ct[n % Ct.length];
}
function ya(t) {
  const n = t.trim();
  return n ? n[0].toUpperCase() : "?";
}
const Bt = 6e4, St = 36e5, Lt = 864e5, ga = 6048e5;
function va(t) {
  const n = new Date(t).getTime();
  if (Number.isNaN(n)) return "";
  const a = Date.now() - n;
  if (a < Bt) return "방금";
  if (a < St) return `${Math.floor(a / Bt)}분 전`;
  if (a < Lt) return `${Math.floor(a / St)}시간 전`;
  if (a < ga) return `${Math.floor(a / Lt)}일 전`;
  const o = new Date(n), r = (l) => l < 10 ? `0${l}` : String(l);
  return `${o.getFullYear()}.${r(o.getMonth() + 1)}.${r(o.getDate())}`;
}
function dt({
  placeholder: t,
  submitLabel: n,
  autoFocus: a,
  initialValue: o,
  onSubmit: r,
  onCancel: l
}) {
  const [s, c] = y(o != null ? o : ""), [i, u] = y(!1), d = F(null);
  K(() => {
    a && d.current && d.current.focus();
  }, [a]);
  const _ = async () => {
    const p = s.trim();
    if (!p || i) return;
    u(!0);
    const b = await r(p);
    u(!1), b && c("");
  };
  return /* @__PURE__ */ e.createElement("div", { className: B.composer }, /* @__PURE__ */ e.createElement(
    "textarea",
    {
      ref: d,
      className: B.composerInput,
      rows: o === void 0 ? 2 : 3,
      placeholder: t,
      value: s,
      disabled: i,
      onChange: (p) => c(p.target.value),
      onKeyDown: (p) => {
        const b = p.nativeEvent.isComposing;
        p.key === "Enter" && !p.shiftKey && !b && (p.preventDefault(), _()), p.key === "Escape" && l && (p.nativeEvent.stopPropagation(), l());
      }
    }
  ), /* @__PURE__ */ e.createElement("div", { className: B.composerActions }, l && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${B.btn} ${B.btnGhost}`,
      onClick: l,
      disabled: i
    },
    "취소"
  ), /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${B.btn} ${B.btnPrimary}`,
      onClick: () => void _(),
      disabled: i || !s.trim()
    },
    i ? "보내는 중…" : n
  )));
}
function ka({
  item: t,
  replying: n,
  editing: a,
  onReply: o,
  onEdit: r,
  onSubmitReply: l,
  onSubmitEdit: s,
  onDelete: c,
  onCancel: i
}) {
  var p, b;
  const u = Mn(t), d = u ? ` ${B.isReply}` : "";
  if (t.deleted)
    return /* @__PURE__ */ e.createElement("div", { className: `${B.row}${d}` }, /* @__PURE__ */ e.createElement("span", { className: `${B.avatar} ${B.avatarGhost}` }, "·"), /* @__PURE__ */ e.createElement("div", { className: B.body }, /* @__PURE__ */ e.createElement("div", { className: `${B.text} ${B.textDeleted}` }, "삭제된 댓글입니다")));
  const _ = (p = t.authorName) != null ? p : "anonymous";
  return /* @__PURE__ */ e.createElement("div", { className: `${B.row}${d}${t.pending ? ` ${B.pending}` : ""}` }, /* @__PURE__ */ e.createElement("span", { className: B.avatar, style: { background: Ea(_) } }, ya(_)), /* @__PURE__ */ e.createElement("div", { className: B.body }, /* @__PURE__ */ e.createElement("div", { className: B.meta }, /* @__PURE__ */ e.createElement("span", { className: B.author }, _), t.dept && /* @__PURE__ */ e.createElement("span", { className: B.dept }, t.dept), /* @__PURE__ */ e.createElement("span", { className: B.time }, va(t.createdAt)), t.updatedAt && /* @__PURE__ */ e.createElement("span", { className: B.time }, "(수정됨)")), a ? /* @__PURE__ */ e.createElement(
    dt,
    {
      placeholder: "댓글을 수정합니다",
      submitLabel: "수정",
      autoFocus: !0,
      initialValue: (b = t.content) != null ? b : "",
      onSubmit: s,
      onCancel: i
    }
  ) : /* @__PURE__ */ e.createElement("div", { className: B.text }, t.content), !a && !t.pending && /* @__PURE__ */ e.createElement("div", { className: B.acts }, !u && /* @__PURE__ */ e.createElement("button", { type: "button", className: B.act, onClick: o }, "답글"), t.mine && /* @__PURE__ */ e.createElement("button", { type: "button", className: B.act, onClick: r }, "수정"), t.mine && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${B.act} ${B.actDanger}`,
      onClick: c
    },
    "삭제"
  )), n && /* @__PURE__ */ e.createElement(
    dt,
    {
      placeholder: `${_} 님에게 답글`,
      submitLabel: "답글 등록",
      autoFocus: !0,
      onSubmit: l,
      onCancel: i
    }
  )));
}
function R_({
  targetType: t,
  targetId: n,
  onCountChange: a,
  autoFocus: o,
  showHeader: r = !0,
  className: l,
  style: s
}) {
  const { items: c, initialLoading: i, loading: u, error: d, count: _, hasMore: p, loadMore: b, reload: f, add: m, edit: h, remove: v } = zn(t, n), [w, E] = y(null), [N, $] = y(null);
  K(() => {
    E(null), $(null);
  }, [t, n]);
  const k = F(a);
  return k.current = a, K(() => {
    !i && k.current && k.current(_);
  }, [_, i]), /* @__PURE__ */ e.createElement("div", { className: l ? `${B.thread} ${l}` : B.thread, style: s }, r && /* @__PURE__ */ e.createElement("div", { className: B.head }, /* @__PURE__ */ e.createElement("span", { className: B.headTitle }, "댓글"), /* @__PURE__ */ e.createElement("span", { className: B.headCount }, _)), /* @__PURE__ */ e.createElement("div", { className: B.list }, i && /* @__PURE__ */ e.createElement("div", { className: B.skeleton }, /* @__PURE__ */ e.createElement("span", null), /* @__PURE__ */ e.createElement("span", null), /* @__PURE__ */ e.createElement("span", null)), d && /* @__PURE__ */ e.createElement("div", { className: B.error }, /* @__PURE__ */ e.createElement("span", null, d), /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${B.btn} ${B.btnGhost}`,
      onClick: f
    },
    "다시 시도"
  )), !i && !d && c.length === 0 && /* @__PURE__ */ e.createElement("div", { className: B.empty }, "첫 댓글을 남겨 보세요."), c.map((x) => /* @__PURE__ */ e.createElement(
    ka,
    {
      key: x.id,
      item: x,
      replying: w === x.id,
      editing: N === x.id,
      onReply: () => {
        $(null), E(x.id);
      },
      onEdit: () => {
        E(null), $(x.id);
      },
      onCancel: () => {
        E(null), $(null);
      },
      onSubmitReply: async (I) => {
        const C = await m(I, x.id);
        return C && E(null), C;
      },
      onSubmitEdit: async (I) => {
        const C = await h(x.id, I);
        return C && $(null), C;
      },
      onDelete: () => {
        v(x.id);
      }
    }
  )), p && /* @__PURE__ */ e.createElement("button", { type: "button", className: B.more, onClick: b, disabled: u }, u ? "불러오는 중…" : "이전 댓글 더 보기")), /* @__PURE__ */ e.createElement("div", { className: B.foot }, /* @__PURE__ */ e.createElement(
    dt,
    {
      placeholder: "댓글을 입력하세요 (Enter 전송, Shift+Enter 줄바꿈)",
      submitLabel: "등록",
      autoFocus: o,
      onSubmit: (x) => m(x)
    }
  )));
}
function T_(t, n) {
  const [a, o] = y({}), [r, l] = y(!1), [s, c] = y(0), i = n.join(",");
  return K(() => {
    const u = i ? i.split(",") : [];
    if (u.length === 0) {
      o({});
      return;
    }
    const d = new AbortController();
    return l(!0), Tn(t, u, d.signal).then((_) => {
      d.signal.aborted || o(_);
    }).catch(() => {
      d.signal.aborted || o({});
    }).finally(() => {
      d.signal.aborted || l(!1);
    }), () => d.abort();
  }, [t, i, s]), {
    counts: a,
    loading: r,
    reload: () => c((u) => u + 1)
  };
}
const Na = "_card_epi3f_1", wa = "_header_epi3f_8", $a = "_headerNoDivider_epi3f_13", xa = "_body_epi3f_17", Ca = "_paddingSm_epi3f_22", Ba = "_paddingMd_epi3f_26", Sa = "_paddingLg_epi3f_30", me = {
  card: Na,
  header: wa,
  headerNoDivider: $a,
  body: xa,
  paddingSm: Ca,
  paddingMd: Ba,
  paddingLg: Sa
};
function q_({
  children: t,
  header: n,
  padding: a = "md",
  radius: o,
  headerDivider: r = !0,
  headerBackground: l,
  headerPadding: s,
  headerBorderColor: c,
  className: i
}) {
  const u = typeof a == "number" ? "" : a === "sm" ? me.paddingSm : a === "lg" ? me.paddingLg : me.paddingMd, d = typeof a == "number" ? { padding: a } : void 0, _ = i ? `${me.card} ${i}` : me.card, p = r ? me.header : `${me.header} ${me.headerNoDivider}`, b = {
    ...l !== void 0 ? { background: l } : {},
    ...s !== void 0 ? { padding: s } : {},
    ...c !== void 0 ? { borderBottomColor: c } : {}
  };
  return /* @__PURE__ */ e.createElement("div", { className: _, style: o !== void 0 ? { borderRadius: o } : void 0 }, n && /* @__PURE__ */ e.createElement("div", { className: p, style: b }, n), /* @__PURE__ */ e.createElement("div", { className: `${me.body} ${u}`, style: d }, t));
}
const La = "_horizontal_mkht7_1", Aa = "_vertical_mkht7_8", At = {
  horizontal: La,
  vertical: Aa
};
function z_({ orientation: t = "horizontal", spacing: n = 0, color: a }) {
  const o = t === "vertical";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: o ? At.vertical : At.horizontal,
      style: {
        ...o ? { marginLeft: n, marginRight: n } : { marginTop: n, marginBottom: n },
        ...a !== void 0 ? { backgroundColor: a } : {}
      },
      role: "separator",
      "aria-orientation": t
    }
  );
}
const ja = "_root_nvy8t_1", Fa = "_icon_nvy8t_7", Ma = "_iconBadge_nvy8t_15", Da = "_titleGroup_nvy8t_25", Ia = "_title_nvy8t_25", Ra = "_subtitle_nvy8t_41", Ta = "_trailing_nvy8t_49", qa = "_closeButton_nvy8t_58", ve = {
  root: ja,
  icon: Fa,
  iconBadge: Ma,
  titleGroup: Da,
  title: Ia,
  subtitle: Ra,
  trailing: Ta,
  closeButton: qa
};
function P_({
  icon: t,
  iconColor: n,
  iconBadge: a = !1,
  iconBadgeColor: o = "#3b82f6",
  iconBadgeGradient: r,
  iconBadgeSize: l,
  title: s,
  titleWeight: c,
  titleSize: i,
  subtitle: u,
  subtitleColor: d,
  subtitleSize: _,
  trailing: p,
  onClose: b
}) {
  const f = {
    ...c !== void 0 ? { fontWeight: c } : {},
    ...i !== void 0 ? { fontSize: i } : {}
  }, m = {
    ...d !== void 0 ? { color: d } : {},
    ..._ !== void 0 ? { fontSize: _ } : {}
  };
  return /* @__PURE__ */ e.createElement("div", { className: ve.root }, t && a && /* @__PURE__ */ e.createElement(
    "span",
    {
      className: ve.iconBadge,
      style: {
        ...r ? { background: `linear-gradient(135deg, ${r[0]}, ${r[1]})`, color: "#fff" } : { backgroundColor: `${o}1A`, color: o },
        ...l !== void 0 ? { width: l, height: l } : {}
      }
    },
    t
  ), t && !a && /* @__PURE__ */ e.createElement("span", { className: ve.icon, style: n !== void 0 ? { color: n } : void 0 }, t), /* @__PURE__ */ e.createElement("div", { className: ve.titleGroup }, /* @__PURE__ */ e.createElement("span", { className: ve.title, style: f }, s), u && /* @__PURE__ */ e.createElement("span", { className: ve.subtitle, style: m }, u)), p && /* @__PURE__ */ e.createElement("div", { className: ve.trailing }, p), b && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: ve.closeButton,
      onClick: b,
      "aria-label": "닫기"
    },
    "×"
  ));
}
const za = "_badge_19977_1", Pa = {
  badge: za
};
function X_({
  size: t = 32,
  gradient: n = ["#7C3AED", "#3B82F6"],
  icon: a
}) {
  const o = t * 0.55;
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: Pa.badge,
      style: {
        width: t,
        height: t,
        background: `linear-gradient(135deg, ${n[0]}, ${n[1]})`
      }
    },
    a != null ? a : /* @__PURE__ */ e.createElement("svg", { width: o, height: o, viewBox: "0 0 24 24", fill: "#fff" }, /* @__PURE__ */ e.createElement("path", { d: "M12 2 L13.5 10.5 L22 12 L13.5 13.5 L12 22 L10.5 13.5 L2 12 L10.5 10.5 Z" }))
  );
}
const Xa = "_wrapper_ccmq2_1", Oa = "_image_ccmq2_8", Wa = "_fallback_ccmq2_16", Ga = "_statusDot_ccmq2_29", et = {
  wrapper: Xa,
  image: Oa,
  fallback: Wa,
  statusDot: Ga
}, Ka = {
  on: "#22C55E",
  away: "#F59E0B",
  off: "#94A3B8"
};
function Ha(t) {
  const n = t == null ? void 0 : t.trim();
  return n ? Array.from(n)[0].toUpperCase() : "";
}
const lt = [
  "#EF4444",
  "#F97316",
  "#F59E0B",
  "#10B981",
  "#0EA5E9",
  "#3B82F6",
  "#6366F1",
  "#8B5CF6",
  "#D946EF",
  "#EC4899"
];
function Ua(t) {
  const n = t == null ? void 0 : t.trim();
  if (!n) return lt[5];
  let a = 0;
  for (let o = 0; o < n.length; o += 1)
    a = a * 31 + n.charCodeAt(o) | 0;
  return lt[Math.abs(a) % lt.length];
}
function tn({
  src: t,
  fallbackText: n,
  alt: a,
  size: o = 32,
  statusDot: r,
  color: l,
  ring: s = !1,
  ringColor: c = "#fff"
}) {
  var _;
  const [i, u] = y(), d = !!t && i !== t;
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: et.wrapper,
      style: {
        width: o,
        height: o,
        ...s ? { boxShadow: `0 0 0 2px ${c}` } : {}
      }
    },
    d ? /* @__PURE__ */ e.createElement(
      "img",
      {
        className: et.image,
        src: t,
        alt: (_ = a != null ? a : n) != null ? _ : "",
        onError: () => u(t)
      }
    ) : /* @__PURE__ */ e.createElement(
      "span",
      {
        className: et.fallback,
        style: {
          backgroundColor: l != null ? l : Ua(n),
          fontSize: Math.max(10, o * 0.45)
        }
      },
      Ha(n)
    ),
    r && /* @__PURE__ */ e.createElement(
      "span",
      {
        className: et.statusDot,
        style: {
          backgroundColor: Ka[r],
          width: Math.max(8, o * 0.28),
          height: Math.max(8, o * 0.28)
        }
      }
    )
  );
}
const Ya = "_stack_y8phg_1", Va = "_item_y8phg_6", Ja = "_overflow_y8phg_18", tt = {
  stack: Ya,
  item: Va,
  overflow: Ja
};
function O_({
  avatars: t,
  max: n = 4,
  size: a = 32
}) {
  const o = t.slice(0, n), r = t.length - o.length;
  return /* @__PURE__ */ e.createElement("span", { className: tt.stack }, o.map((l, s) => /* @__PURE__ */ e.createElement("span", { key: s, className: tt.item, style: { zIndex: o.length - s } }, /* @__PURE__ */ e.createElement(tn, { src: l.src, alt: l.alt, fallbackText: l.fallbackText, size: a }))), r > 0 && /* @__PURE__ */ e.createElement("span", { className: tt.item, style: { zIndex: 0 } }, /* @__PURE__ */ e.createElement(
    "span",
    {
      className: tt.overflow,
      style: { width: a, height: a, fontSize: Math.max(10, a * 0.36) }
    },
    "+",
    r
  )));
}
const Za = "_badge_1mjda_1", Qa = "_pill_1mjda_15", eo = "_dot_1mjda_19", to = "_dotPulse_1mjda_26", no = "_outline_1mjda_40", ao = "_soft_1mjda_46", ze = {
  badge: Za,
  pill: Qa,
  dot: eo,
  dotPulse: to,
  "ax-badge-pulse": "_ax-badge-pulse_1mjda_1",
  default: "_default_1mjda_35",
  outline: no,
  soft: ao
};
function W_({
  label: t,
  variant: n = "default",
  color: a,
  background: o,
  textColor: r,
  shape: l = "rounded",
  dot: s = !1,
  dotColor: c,
  dotPulse: i = !1,
  border: u = !1,
  borderColor: d = "currentColor"
}) {
  var f;
  const _ = {};
  a && (n === "default" ? (_.backgroundColor = a, _.color = "#fff") : n === "outline" ? (_.borderColor = a, _.color = a) : (_.backgroundColor = `${a}1A`, _.color = a)), o !== void 0 && (_.backgroundColor = o), r !== void 0 && (_.color = r), u && (_.borderColor = d);
  const p = [
    ze.badge,
    ze[n],
    l === "pill" ? ze.pill : ""
  ].filter(Boolean).join(" "), b = [ze.dot, i ? ze.dotPulse : ""].filter(Boolean).join(" ");
  return /* @__PURE__ */ e.createElement("span", { className: p, style: _ }, s && /* @__PURE__ */ e.createElement("span", { className: b, style: { backgroundColor: c != null ? c : (f = r != null ? r : a) != null ? f : "currentColor" } }), t);
}
const oo = "_row_1k2ap_1", ro = "_reply_1k2ap_7", lo = "_avatar_1k2ap_12", so = "_avatarImage_1k2ap_25", co = "_avatarFallback_1k2ap_32", io = "_body_1k2ap_44", uo = "_headerLine_1k2ap_49", mo = "_author_1k2ap_56", _o = "_meta_1k2ap_62", po = "_text_1k2ap_67", fo = "_actionsRow_1k2ap_74", bo = "_actionBtn_1k2ap_81", J = {
  row: oo,
  reply: ro,
  avatar: lo,
  avatarImage: so,
  avatarFallback: co,
  body: io,
  headerLine: uo,
  author: mo,
  meta: _o,
  text: po,
  actionsRow: fo,
  actionBtn: bo
};
function ho(t) {
  const n = t.trim();
  return n ? n[0].toUpperCase() : "";
}
function G_({
  avatarSrc: t,
  author: n,
  meta: a,
  text: o,
  likeCount: r,
  replyCount: l,
  isReply: s = !1,
  onLikeClick: c,
  onReplyClick: i
}) {
  const [u, d] = y(!1), _ = !!t && !u;
  return /* @__PURE__ */ e.createElement("div", { className: `${J.row} ${s ? J.reply : ""}` }, /* @__PURE__ */ e.createElement("span", { className: J.avatar }, _ ? /* @__PURE__ */ e.createElement(
    "img",
    {
      className: J.avatarImage,
      src: t,
      alt: n,
      onError: () => d(!0)
    }
  ) : /* @__PURE__ */ e.createElement("span", { className: J.avatarFallback }, ho(n))), /* @__PURE__ */ e.createElement("div", { className: J.body }, /* @__PURE__ */ e.createElement("div", { className: J.headerLine }, /* @__PURE__ */ e.createElement("span", { className: J.author }, n), a && /* @__PURE__ */ e.createElement("span", { className: J.meta }, a)), /* @__PURE__ */ e.createElement("div", { className: J.text }, o), /* @__PURE__ */ e.createElement("div", { className: J.actionsRow }, /* @__PURE__ */ e.createElement("button", { type: "button", className: J.actionBtn, onClick: c }, /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" })), typeof r == "number" && /* @__PURE__ */ e.createElement("span", null, r)), /* @__PURE__ */ e.createElement("button", { type: "button", className: J.actionBtn, onClick: i }, /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })), typeof l == "number" && /* @__PURE__ */ e.createElement("span", null, l)))));
}
const Eo = "_wrapper_79n51_1", yo = {
  wrapper: Eo
}, go = {
  pdf: { label: "PDF", color: "#B91C1C", bg: "#FEF2F2" },
  doc: { label: "DOC", color: "#1D4ED8", bg: "#EFF6FF" },
  docx: { label: "DOC", color: "#1D4ED8", bg: "#EFF6FF" },
  xls: { label: "XLS", color: "#166534", bg: "#F0FDF4" },
  xlsx: { label: "XLS", color: "#166534", bg: "#F0FDF4" },
  ppt: { label: "PPT", color: "#92400E", bg: "#FFFBEB" },
  pptx: { label: "PPT", color: "#92400E", bg: "#FFFBEB" },
  zip: { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  rar: { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  "7z": { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  jpg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  jpeg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  png: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  gif: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  svg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  mp4: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  mov: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  avi: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  txt: { label: "TXT", color: "#334155", bg: "#F8FAFC" }
}, vo = { label: "FILE", color: "#64748B", bg: "#F1F5F9" };
function ko({ ext: t, size: n = 32 }) {
  var s;
  const a = t.trim().toLowerCase().replace(/^\./, ""), { label: o, color: r, bg: l } = (s = go[a]) != null ? s : vo;
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: yo.wrapper,
      style: {
        width: n,
        height: n,
        backgroundColor: l,
        color: r,
        fontSize: Math.max(8, n * 0.26)
      }
    },
    o
  );
}
const No = "_chip_1jhj8_1", wo = "_clickable_1jhj8_12", $o = "_icon_1jhj8_21", xo = "_info_1jhj8_26", Co = "_name_1jhj8_33", Bo = "_size_1jhj8_42", So = "_chipError_1jhj8_48", Lo = "_chipDone_1jhj8_53", Ao = "_status_1jhj8_57", jo = "_statusError_1jhj8_66", Fo = "_statusDone_1jhj8_67", Mo = "_statusIcon_1jhj8_69", Do = "_statusLabel_1jhj8_71", Io = "_progressTrack_1jhj8_78", Ro = "_progressFill_1jhj8_88", To = "_actionBtn_1jhj8_96", O = {
  chip: No,
  clickable: wo,
  icon: $o,
  info: xo,
  name: Co,
  size: Bo,
  chipError: So,
  chipDone: Lo,
  status: Ao,
  statusError: jo,
  statusDone: Fo,
  statusIcon: Mo,
  statusLabel: Do,
  progressTrack: Io,
  progressFill: Ro,
  actionBtn: To
};
function K_({
  name: t,
  ext: n,
  size: a,
  onRemove: o,
  downloadable: r = !1,
  onClick: l,
  status: s,
  statusText: c,
  percent: i
}) {
  const u = s === "error" ? O.chipError : s === "done" ? O.chipDone : "";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: `${O.chip} ${l ? O.clickable : ""} ${u}`,
      onClick: l,
      title: s === "error" ? c : void 0
    },
    n && /* @__PURE__ */ e.createElement("span", { className: O.icon }, /* @__PURE__ */ e.createElement(ko, { ext: n, size: 28 })),
    /* @__PURE__ */ e.createElement("span", { className: O.info }, /* @__PURE__ */ e.createElement("span", { className: O.name }, t), c ? /* @__PURE__ */ e.createElement("span", { className: `${O.status} ${s === "error" ? O.statusError : s === "done" ? O.statusDone : ""}` }, s === "error" && /* @__PURE__ */ e.createElement("svg", { className: O.statusIcon, width: "11", height: "11", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.4", strokeLinecap: "round" }, /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "9" }), /* @__PURE__ */ e.createElement("path", { d: "M12 7v6M12 16.5v.01" })), s === "done" && /* @__PURE__ */ e.createElement("svg", { className: O.statusIcon, width: "11", height: "11", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.6", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M4 12.5l5 5L20 6.5" })), /* @__PURE__ */ e.createElement("span", { className: O.statusLabel }, c)) : a ? /* @__PURE__ */ e.createElement("span", { className: O.size }, a) : null, s === "processing" && /* @__PURE__ */ e.createElement("span", { className: O.progressTrack }, /* @__PURE__ */ e.createElement("span", { className: O.progressFill, style: { width: `${Math.max(0, Math.min(100, i != null ? i : 0))}%` } }))),
    r ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: O.actionBtn,
        "aria-label": "download",
        onClick: (d) => d.stopPropagation()
      },
      /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M12 3v12M7 10l5 5 5-5M4 21h16" }))
    ) : o ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: O.actionBtn,
        "aria-label": "remove",
        onClick: (d) => {
          d.stopPropagation(), o();
        }
      },
      /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M18 6L6 18M6 6l12 12" }))
    ) : null
  );
}
const qo = "_list_1yxwc_1", zo = "_row_1yxwc_6", Po = "_inline_1yxwc_15", Xo = "_label_1yxwc_22", Oo = "_value_1yxwc_29", Wo = "_stacked_1yxwc_35", Go = "_bold_1yxwc_51", Le = {
  list: qo,
  row: zo,
  inline: Po,
  label: Xo,
  value: Oo,
  stacked: Wo,
  bold: Go
};
function H_({
  rows: t,
  direction: n = "inline"
}) {
  return /* @__PURE__ */ e.createElement("div", { className: `${Le.list} ${Le[n]}` }, t.map((a, o) => /* @__PURE__ */ e.createElement("div", { key: o, className: Le.row }, /* @__PURE__ */ e.createElement("span", { className: Le.label }, a.label), /* @__PURE__ */ e.createElement("span", { className: `${Le.value} ${a.bold ? Le.bold : ""}` }, a.value))));
}
const Ko = "_container_2r163_1", Ho = "_row_2r163_5", Uo = "_clickable_2r163_12", Yo = "_leading_2r163_20", Vo = "_main_2r163_26", Jo = "_titleLine_2r163_34", Zo = "_title_2r163_34", Qo = "_tags_2r163_50", er = "_meta_2r163_57", tr = "_actions_2r163_62", nr = "_expandable_2r163_69", ne = {
  container: Ko,
  row: Ho,
  clickable: Uo,
  leading: Yo,
  main: Vo,
  titleLine: Jo,
  title: Zo,
  tags: Qo,
  meta: er,
  actions: tr,
  expandable: nr
};
function U_({
  leading: t,
  title: n,
  meta: a,
  tags: o,
  actions: r,
  expandableContent: l,
  expanded: s = !1,
  onClick: c
}) {
  return /* @__PURE__ */ e.createElement("div", { className: ne.container }, /* @__PURE__ */ e.createElement("div", { className: `${ne.row} ${c ? ne.clickable : ""}`, onClick: c }, t && /* @__PURE__ */ e.createElement("div", { className: ne.leading }, t), /* @__PURE__ */ e.createElement("div", { className: ne.main }, /* @__PURE__ */ e.createElement("div", { className: ne.titleLine }, /* @__PURE__ */ e.createElement("span", { className: ne.title }, n), o && /* @__PURE__ */ e.createElement("span", { className: ne.tags }, o)), a && /* @__PURE__ */ e.createElement("div", { className: ne.meta }, a)), r && /* @__PURE__ */ e.createElement("div", { className: ne.actions, onClick: (i) => i.stopPropagation() }, r)), s && l && /* @__PURE__ */ e.createElement("div", { className: ne.expandable }, l));
}
const ar = "_row_xzgny_1", or = "_info_xzgny_8", rr = "_name_xzgny_16", lr = "_subtitle_xzgny_25", sr = "_status_xzgny_33", Pe = {
  row: ar,
  info: or,
  name: rr,
  subtitle: lr,
  status: sr
};
function Y_({
  avatarSrc: t,
  name: n,
  subtitle: a,
  status: o,
  statusColor: r = "#64748B",
  statusBg: l = "#F1F5F9"
}) {
  return /* @__PURE__ */ e.createElement("div", { className: Pe.row }, /* @__PURE__ */ e.createElement(tn, { src: t, fallbackText: n, size: 36 }), /* @__PURE__ */ e.createElement("div", { className: Pe.info }, /* @__PURE__ */ e.createElement("span", { className: Pe.name }, n), a && /* @__PURE__ */ e.createElement("span", { className: Pe.subtitle }, a)), o && /* @__PURE__ */ e.createElement(
    "span",
    {
      className: Pe.status,
      style: { color: r, backgroundColor: l }
    },
    o
  ));
}
const cr = "_row_qoxwr_1", ir = "_clickable_qoxwr_9", ur = "_rank_qoxwr_17", mr = "_title_qoxwr_25", dr = "_trailing_qoxwr_36", Xe = {
  row: cr,
  clickable: ir,
  rank: ur,
  title: mr,
  trailing: dr
}, _r = {
  1: "#F59E0B",
  2: "#94A3B8",
  3: "#B45309"
};
function V_({
  rank: t,
  rankColor: n,
  title: a,
  trailingText: o,
  onClick: r
}) {
  var s;
  const l = (s = n != null ? n : _r[t]) != null ? s : "#64748B";
  return /* @__PURE__ */ e.createElement("div", { className: `${Xe.row} ${r ? Xe.clickable : ""}`, onClick: r }, /* @__PURE__ */ e.createElement("span", { className: Xe.rank, style: { color: l } }, t), /* @__PURE__ */ e.createElement("span", { className: Xe.title }, a), o && /* @__PURE__ */ e.createElement("span", { className: Xe.trailing }, o));
}
const pr = "_badge_1qibj_1", fr = "_sm_1qibj_11", br = "_md_1qibj_16", hr = "_overdue_1qibj_21", Er = "_warning_1qibj_26", yr = "_progress_1qibj_31", gr = "_success_1qibj_36", vr = "_info_1qibj_41", kr = "_neutral_1qibj_46", st = {
  badge: pr,
  sm: fr,
  md: br,
  overdue: hr,
  warning: Er,
  progress: yr,
  success: gr,
  info: vr,
  neutral: kr
};
function J_({
  label: t,
  tone: n = "neutral",
  size: a = "md",
  background: o,
  textColor: r
}) {
  const l = {};
  return o !== void 0 && (l.backgroundColor = o), r !== void 0 && (l.color = r), /* @__PURE__ */ e.createElement("span", { className: `${st.badge} ${st[n]} ${st[a]}`, style: l }, t);
}
const Nr = "_wrapper_14p14_1", wr = "_avatar_14p14_11", $r = "_body_14p14_21", xr = "_message_14p14_26", Cr = "_dots_14p14_32", Br = "_dot_14p14_32", Sr = "_action_14p14_70", Lr = "_actionIcon_14p14_89", Ar = "_gradientWrapper_14p14_95", jr = "_bareIcon_14p14_100", Fr = "_ctaButton_14p14_109", U = {
  wrapper: Nr,
  avatar: wr,
  body: $r,
  message: xr,
  dots: Cr,
  dot: Br,
  action: Sr,
  actionIcon: Lr,
  gradientWrapper: Ar,
  bareIcon: jr,
  ctaButton: Fr
};
function jt() {
  return /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8 1.5l1.4 3.9L13.3 6.8l-3.9 1.4L8 12.1l-1.4-3.9L2.7 6.8l3.9-1.4L8 1.5z",
      fill: "currentColor"
    }
  ));
}
function Ft() {
  return /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M3 7h8M7.5 3.5L11 7l-3.5 3.5",
      stroke: "currentColor",
      strokeWidth: "1.6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ));
}
function Z_({
  message: t,
  accentColor: n = "#7C3AED",
  buttonLabel: a,
  buttonIcon: o,
  onAction: r,
  phase: l = "complete",
  variant: s = "card",
  gradientColors: c = ["#EEF4FF", "#F3EEFF"]
}) {
  const i = s === "gradient-cta";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [U.wrapper, i ? U.gradientWrapper : ""].join(" "),
      style: i ? { borderColor: `${n}33`, background: `linear-gradient(135deg, ${c[0]}, ${c[1]})` } : { borderColor: `${n}33` }
    },
    i ? /* @__PURE__ */ e.createElement("span", { className: U.bareIcon, style: { color: n } }, /* @__PURE__ */ e.createElement(jt, null)) : /* @__PURE__ */ e.createElement(
      "span",
      {
        className: U.avatar,
        style: { backgroundColor: `${n}1A`, color: n }
      },
      /* @__PURE__ */ e.createElement(jt, null)
    ),
    /* @__PURE__ */ e.createElement("div", { className: U.body }, l === "loading" ? /* @__PURE__ */ e.createElement("span", { className: U.dots }, /* @__PURE__ */ e.createElement("span", { className: U.dot, style: { backgroundColor: n } }), /* @__PURE__ */ e.createElement("span", { className: U.dot, style: { backgroundColor: n } }), /* @__PURE__ */ e.createElement("span", { className: U.dot, style: { backgroundColor: n } })) : /* @__PURE__ */ e.createElement("span", { className: U.message, style: i ? { color: n } : void 0 }, t)),
    a && r && (i ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: U.ctaButton,
        style: { backgroundColor: n },
        onClick: r
      },
      /* @__PURE__ */ e.createElement("span", null, a),
      /* @__PURE__ */ e.createElement("span", { className: U.actionIcon }, o === void 0 ? /* @__PURE__ */ e.createElement(Ft, null) : o)
    ) : /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: U.action,
        style: { color: n },
        onClick: r
      },
      /* @__PURE__ */ e.createElement("span", null, a),
      /* @__PURE__ */ e.createElement("span", { className: U.actionIcon }, o === void 0 ? /* @__PURE__ */ e.createElement(Ft, null) : o)
    ))
  );
}
const Mr = "_wrapper_68zkp_1", Dr = "_bordered_68zkp_13", Ir = "_compact_68zkp_17", Rr = "_icon_68zkp_23", Tr = "_title_68zkp_31", qr = "_description_68zkp_38", zr = "_action_68zkp_46", we = {
  wrapper: Mr,
  bordered: Dr,
  compact: Ir,
  icon: Rr,
  title: Tr,
  description: qr,
  action: zr
};
function Pr() {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 15L20 8l14 7-14 7-14-7z",
        stroke: "#94A3B8",
        strokeWidth: "1.6",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 15v11l14 7 14-7V15",
        stroke: "#94A3B8",
        strokeWidth: "1.6",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ e.createElement("path", { d: "M20 22v11", stroke: "#94A3B8", strokeWidth: "1.6", strokeLinecap: "round" })
  );
}
function Q_({
  icon: t,
  hideIcon: n = !1,
  title: a,
  titleColor: o,
  titleSize: r,
  titleWeight: l,
  description: s,
  actionLabel: c,
  onAction: i,
  bordered: u = !0,
  compact: d = !1
}) {
  const _ = {
    ...o !== void 0 ? { color: o } : {},
    ...r !== void 0 ? { fontSize: r } : {},
    ...l !== void 0 ? { fontWeight: l } : {}
  };
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [we.wrapper, u && !d ? we.bordered : "", d ? we.compact : ""].join(" ")
    },
    !n && /* @__PURE__ */ e.createElement("div", { className: we.icon }, t != null ? t : /* @__PURE__ */ e.createElement(Pr, null)),
    /* @__PURE__ */ e.createElement("p", { className: we.title, style: _ }, a),
    s && /* @__PURE__ */ e.createElement("p", { className: we.description }, s),
    c && i && /* @__PURE__ */ e.createElement("button", { type: "button", className: we.action, onClick: i }, c)
  );
}
const Xr = "_wrapper_oide4_1", Or = "_toggle_oide4_7", Wr = "_toggleOpen_oide4_29", Gr = "_panel_oide4_34", Kr = "_text_oide4_41", Oe = {
  wrapper: Xr,
  toggle: Or,
  toggleOpen: Wr,
  panel: Gr,
  text: Kr
};
function ep({
  label: t,
  summaryText: n,
  open: a,
  onToggle: o
}) {
  return /* @__PURE__ */ e.createElement("div", { className: Oe.wrapper }, /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: [Oe.toggle, a ? Oe.toggleOpen : ""].join(" "),
      onClick: o,
      "aria-expanded": a
    },
    t
  ), a && /* @__PURE__ */ e.createElement("div", { className: Oe.panel }, /* @__PURE__ */ e.createElement("p", { className: Oe.text }, n)));
}
const Hr = "_wrapper_96dw1_1", Ur = "_labelRow_96dw1_8", Yr = "_label_96dw1_8", Vr = "_value_96dw1_21", Jr = "_track_96dw1_27", Zr = "_xs_96dw1_35", Qr = "_sm_96dw1_39", el = "_md_96dw1_43", tl = "_square_96dw1_47", nl = "_fill_96dw1_51", de = {
  wrapper: Hr,
  labelRow: Ur,
  label: Yr,
  value: Vr,
  track: Jr,
  xs: Zr,
  sm: Qr,
  md: el,
  square: tl,
  fill: nl
};
function tp({
  value: t,
  max: n = 100,
  label: a,
  color: o = "#3B82F6",
  gradient: r,
  size: l = "md",
  rounded: s = !0,
  height: c,
  trackColor: i
}) {
  const u = n > 0 ? n : 100, d = Math.min(100, Math.max(0, t / u * 100)), _ = r ? { width: `${d}%`, background: `linear-gradient(90deg, ${r[0]}, ${r[1]})` } : { width: `${d}%`, backgroundColor: o }, p = {
    ...c !== void 0 ? { height: c } : {},
    ...i !== void 0 ? { background: i } : {}
  };
  return /* @__PURE__ */ e.createElement("div", { className: de.wrapper }, a && /* @__PURE__ */ e.createElement("div", { className: de.labelRow }, /* @__PURE__ */ e.createElement("span", { className: de.label }, a), /* @__PURE__ */ e.createElement("span", { className: de.value }, Math.round(d), "%")), /* @__PURE__ */ e.createElement("div", { className: [de.track, de[l], s ? "" : de.square].join(" "), style: p }, /* @__PURE__ */ e.createElement("div", { className: [de.fill, s ? "" : de.square].join(" "), style: _ })));
}
const al = "_list_aixh6_1", ol = "_vertical_aixh6_8", rl = "_horizontal_aixh6_13", ll = "_item_aixh6_18", sl = "_iconWrap_aixh6_41", cl = "_iconSvg_aixh6_51", il = "_spin_aixh6_56", ul = "_label_aixh6_70", ml = "_item_active_aixh6_82", dl = "_item_done_aixh6_87", _l = "_connector_aixh6_91", pl = "_cardList_aixh6_114", fl = "_cardItem_aixh6_122", bl = "_card_pending_aixh6_133", hl = "_card_active_aixh6_142", El = "_card_done_aixh6_152", V = {
  list: al,
  vertical: ol,
  horizontal: rl,
  item: ll,
  iconWrap: sl,
  iconSvg: cl,
  spin: il,
  "ax-step-spin": "_ax-step-spin_aixh6_1",
  label: ul,
  item_active: ml,
  item_done: dl,
  connector: _l,
  cardList: pl,
  cardItem: fl,
  card_pending: bl,
  card_active: hl,
  card_done: El
};
function yl({ status: t }) {
  return t === "done" ? /* @__PURE__ */ e.createElement(
    "svg",
    {
      className: V.iconSvg,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "10", cy: "10", r: "9", fill: "#F0FDF4", stroke: "#166534", strokeWidth: "1.5" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 10.2l2.4 2.4L14 7",
        stroke: "#166534",
        strokeWidth: "1.7",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  ) : t === "active" ? /* @__PURE__ */ e.createElement(
    "svg",
    {
      className: [V.iconSvg, V.spin].join(" "),
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "circle",
      {
        cx: "10",
        cy: "10",
        r: "8",
        stroke: "#E2E8F0",
        strokeWidth: "2.5"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M18 10a8 8 0 00-8-8",
        stroke: "#3B82F6",
        strokeWidth: "2.5",
        strokeLinecap: "round"
      }
    )
  ) : /* @__PURE__ */ e.createElement(
    "svg",
    {
      className: V.iconSvg,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "10", cy: "10", r: "8", stroke: "#94A3B8", strokeWidth: "1.5" })
  );
}
function np({
  steps: t,
  orientation: n = "vertical",
  variant: a = "timeline"
}) {
  const o = a === "card";
  return /* @__PURE__ */ e.createElement("ul", { className: [V.list, V[n], o ? V.cardList : ""].join(" ") }, t.map((r, l) => /* @__PURE__ */ e.createElement(
    "li",
    {
      key: `${r.label}-${l}`,
      className: [
        V.item,
        o ? V.cardItem : "",
        V[`item_${r.status}`],
        o ? V[`card_${r.status}`] : ""
      ].join(" ")
    },
    /* @__PURE__ */ e.createElement("span", { className: V.iconWrap }, /* @__PURE__ */ e.createElement(yl, { status: r.status })),
    /* @__PURE__ */ e.createElement("span", { className: V.label }, r.label),
    !o && l < t.length - 1 && /* @__PURE__ */ e.createElement("span", { className: V.connector })
  )));
}
const gl = "_wrapper_1ohmw_1", vl = "_icon_1ohmw_7", kl = "_dots_1ohmw_14", Nl = "_dot_1ohmw_14", wl = "_sm_1ohmw_27", $l = "_md_1ohmw_32", $e = {
  wrapper: gl,
  icon: vl,
  dots: kl,
  dot: Nl,
  "ax-typing-bounce": "_ax-typing-bounce_1ohmw_1",
  sm: wl,
  md: $l
};
function ap({ withIcon: t, size: n = "md" }) {
  return /* @__PURE__ */ e.createElement("div", { className: $e.wrapper }, t && /* @__PURE__ */ e.createElement("span", { className: $e.icon }, t), /* @__PURE__ */ e.createElement("span", { className: [$e.dots, $e[n]].join(" ") }, /* @__PURE__ */ e.createElement("span", { className: $e.dot }), /* @__PURE__ */ e.createElement("span", { className: $e.dot }), /* @__PURE__ */ e.createElement("span", { className: $e.dot })));
}
const xl = "_container_85404_1", Cl = "_table_85404_9", Bl = "_row_85404_31", Sl = "_striped_85404_35", Ll = "_clickable_85404_43", Al = "_alignLeft_85404_47", jl = "_alignCenter_85404_51", Fl = "_alignRight_85404_55", Ml = "_emptyCell_85404_59", _e = {
  container: xl,
  table: Cl,
  row: Bl,
  striped: Sl,
  clickable: Ll,
  alignLeft: Al,
  alignCenter: jl,
  alignRight: Fl,
  emptyCell: Ml
};
function op({
  columns: t,
  rows: n,
  striped: a = !0,
  onRowClick: o,
  emptyMessage: r = "데이터가 없습니다"
}) {
  const l = (s) => s === "center" ? _e.alignCenter : s === "right" ? _e.alignRight : _e.alignLeft;
  return /* @__PURE__ */ e.createElement("div", { className: _e.container }, /* @__PURE__ */ e.createElement("table", { className: _e.table }, /* @__PURE__ */ e.createElement("thead", null, /* @__PURE__ */ e.createElement("tr", null, t.map((s) => /* @__PURE__ */ e.createElement(
    "th",
    {
      key: s.key,
      className: l(s.align),
      style: s.width ? { width: s.width } : void 0
    },
    s.label
  )))), /* @__PURE__ */ e.createElement("tbody", null, n.length === 0 ? /* @__PURE__ */ e.createElement("tr", null, /* @__PURE__ */ e.createElement("td", { className: _e.emptyCell, colSpan: t.length }, r)) : n.map((s, c) => {
    const i = [
      _e.row,
      a && c % 2 === 1 ? _e.striped : "",
      o ? _e.clickable : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ e.createElement(
      "tr",
      {
        key: c,
        className: i,
        onClick: o ? () => o(s, c) : void 0
      },
      t.map((u) => /* @__PURE__ */ e.createElement("td", { key: u.key, className: l(u.align) }, s[u.key]))
    );
  }))));
}
const Dl = "_grid_plbcd_1", Il = "_cell_plbcd_6", Rl = "_primaryCell_plbcd_16", Tl = "_label_plbcd_21", ql = "_value_plbcd_26", zl = "_note_plbcd_32", Ae = {
  grid: Dl,
  cell: Il,
  primaryCell: Rl,
  label: Tl,
  value: ql,
  note: zl
};
function rp({
  items: t,
  columns: n = 4,
  primaryFirst: a = !1,
  cellBackground: o,
  cellBorderColor: r,
  labelColor: l,
  valueColor: s,
  primaryBackground: c,
  primaryLabelColor: i,
  primaryValueColor: u,
  primaryNoteColor: d
}) {
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: Ae.grid,
      style: { gridTemplateColumns: `repeat(${n}, 1fr)` }
    },
    t.map((_, p) => {
      const b = a && p === 0, f = [Ae.cell, b ? Ae.primaryCell : ""].filter(Boolean).join(" "), m = {};
      o !== void 0 && (m.background = o), r !== void 0 && (m.borderColor = r), b && c !== void 0 && (m.background = c, m.borderColor = "transparent");
      const h = {};
      l !== void 0 && (h.color = l), b && i !== void 0 && (h.color = i);
      const v = {};
      s !== void 0 && (v.color = s), b && u !== void 0 && (v.color = u);
      const w = {};
      return b && d !== void 0 && (w.color = d), /* @__PURE__ */ e.createElement("div", { key: `${_.label}-${p}`, className: f, style: m }, /* @__PURE__ */ e.createElement("span", { className: Ae.label, style: h }, _.label), /* @__PURE__ */ e.createElement("span", { className: Ae.value, style: v }, _.value), _.note && /* @__PURE__ */ e.createElement("span", { className: Ae.note, style: w }, _.note));
    })
  );
}
const Pl = "_button_16ajt_1", Xl = "_disabledSolid_16ajt_19", Ol = "_icon_16ajt_26", Wl = "_label_16ajt_32", Gl = "_fullWidth_16ajt_37", Kl = "_sm_16ajt_41", Hl = "_md_16ajt_47", Ul = "_lg_16ajt_53", Yl = "_primary_16ajt_59", Vl = "_secondary_16ajt_70", Jl = "_outline_16ajt_81", Zl = "_ghost_16ajt_93", Ql = "_active_16ajt_104", es = "_colorOverride_16ajt_116", ts = "_gradient_16ajt_126", ns = "_dashed_16ajt_135", as = "_pill_16ajt_139", Q = {
  button: Pl,
  disabledSolid: Xl,
  icon: Ol,
  label: Wl,
  fullWidth: Gl,
  sm: Kl,
  md: Hl,
  lg: Ul,
  primary: Yl,
  secondary: Vl,
  outline: Jl,
  ghost: Zl,
  active: Ql,
  colorOverride: es,
  gradient: ts,
  dashed: ns,
  pill: as
};
function lp({
  variant: t = "primary",
  size: n = "md",
  icon: a,
  iconPosition: o = "leading",
  disabled: r = !1,
  disabledVariant: l = "dim",
  onClick: s,
  children: c,
  fullWidth: i = !1,
  type: u = "button",
  active: d = !1,
  color: _,
  background: p,
  borderColor: b,
  hoverColor: f,
  hoverBackground: m,
  gradient: h,
  borderStyle: v = "solid",
  shape: w = "rounded"
}) {
  const E = _ !== void 0 || b !== void 0 || f !== void 0 || m !== void 0, N = [
    Q.button,
    Q[t],
    Q[n],
    i ? Q.fullWidth : "",
    r && l === "solid" ? Q.disabledSolid : "",
    d ? Q.active : "",
    E ? Q.colorOverride : "",
    h || p ? Q.gradient : "",
    v === "dashed" ? Q.dashed : "",
    w === "pill" ? Q.pill : ""
  ].filter(Boolean).join(" "), $ = {
    ..._ !== void 0 ? { "--ax-btn-color": _ } : {},
    ...b !== void 0 ? { "--ax-btn-border": b } : {},
    ...f !== void 0 ? { "--ax-btn-hover-color": f } : {},
    ...m !== void 0 ? { "--ax-btn-hover-bg": m } : {},
    ...h ? { background: `linear-gradient(135deg, ${h[0]}, ${h[1]})` } : {},
    ...p !== void 0 ? { background: p } : {}
  }, k = a && /* @__PURE__ */ e.createElement("span", { className: Q.icon }, a);
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: u,
      className: N,
      style: $,
      disabled: r,
      onClick: s
    },
    o === "leading" && k,
    /* @__PURE__ */ e.createElement("span", { className: Q.label }, c),
    o === "trailing" && k
  );
}
const os = "_iconButton_1oiog_1", rs = "_sm_1oiog_18", ls = "_md_1oiog_23", ss = "_lg_1oiog_28", cs = "_plain_1oiog_33", is = "_outline_1oiog_42", us = "_circle_1oiog_53", ms = "_bordered_1oiog_62", ds = "_tint_1oiog_73", _s = "_active_1oiog_81", ps = "_hoverBgOverride_1oiog_92", fs = "_gradient_1oiog_96", ke = {
  iconButton: os,
  sm: rs,
  md: ls,
  lg: ss,
  plain: cs,
  outline: is,
  circle: us,
  bordered: ms,
  tint: ds,
  active: _s,
  hoverBgOverride: ps,
  gradient: fs
};
function sp({
  icon: t,
  title: n,
  active: a = !1,
  size: o = "md",
  variant: r = "plain",
  onClick: l,
  onMouseDown: s,
  disabled: c = !1,
  color: i,
  hoverColor: u,
  bordered: d = !1,
  borderColor: _ = "#e2e8f0",
  borderHoverColor: p = "#3b82f6",
  tint: b = !1,
  tintColor: f = "#eef4ff",
  tintHoverColor: m = "#dbeafe",
  hoverBackground: h,
  gradient: v
}) {
  const w = typeof o == "number", E = [
    ke.iconButton,
    w ? "" : ke[o],
    ke[r],
    a ? ke.active : "",
    d ? ke.bordered : "",
    b ? ke.tint : "",
    h !== void 0 ? ke.hoverBgOverride : "",
    v ? ke.gradient : ""
  ].filter(Boolean).join(" "), N = {
    ...w ? { width: o, height: o } : {},
    ...i !== void 0 ? { "--ax-icon-color": i } : {},
    ...u !== void 0 ? { "--ax-icon-hover": u } : {},
    ...d ? { "--ax-icon-border": _, "--ax-icon-border-hover": p } : {},
    ...b ? { "--ax-icon-tint": f, "--ax-icon-tint-hover": m } : {},
    ...h !== void 0 ? { "--ax-icon-hover-bg": h } : {},
    ...v ? { background: `linear-gradient(135deg, ${v[0]}, ${v[1]})` } : {}
  };
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: E,
      style: N,
      onClick: l,
      onMouseDown: s,
      disabled: c,
      title: n,
      "aria-label": n
    },
    t
  );
}
const bs = "_wrapper_wrch3_1", hs = "_searchIcon_wrch3_18", Es = "_input_wrch3_26", ys = "_clearButton_wrch3_40", gs = "_hint_wrch3_60", We = {
  wrapper: bs,
  searchIcon: hs,
  input: Es,
  clearButton: ys,
  hint: gs
}, vs = /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("circle", { cx: "11", cy: "11", r: "7" }), /* @__PURE__ */ e.createElement("path", { d: "M21 21l-4.35-4.35" }));
function cp({
  value: t,
  onChange: n,
  placeholder: a,
  hint: o,
  onSubmit: r,
  onClear: l
}) {
  const s = (c) => {
    c.key === "Enter" && (r == null || r());
  };
  return /* @__PURE__ */ e.createElement("div", { className: We.wrapper }, /* @__PURE__ */ e.createElement("span", { className: We.searchIcon }, vs), /* @__PURE__ */ e.createElement(
    "input",
    {
      type: "text",
      className: We.input,
      value: t,
      placeholder: a,
      onChange: (c) => n(c.target.value),
      onKeyDown: s
    }
  ), l && t.length > 0 && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: We.clearButton,
      onClick: l,
      "aria-label": "clear"
    },
    /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M18 6L6 18" }), /* @__PURE__ */ e.createElement("path", { d: "M6 6l12 12" }))
  ), o && /* @__PURE__ */ e.createElement("span", { className: We.hint }, o));
}
const ks = "_control_1kv40_1", Ns = "_option_1kv40_10", ws = "_active_1kv40_28", $s = "_sm_1kv40_37", xs = "_md_1kv40_43", Cs = "_dot_1kv40_49", Bs = "_count_1kv40_56", Ss = "_outline_1kv40_70", Ls = "_outlineOption_1kv40_75", pe = {
  control: ks,
  option: Ns,
  active: ws,
  sm: $s,
  md: xs,
  dot: Cs,
  count: Bs,
  outline: Ss,
  outlineOption: Ls
};
function ip({
  options: t,
  value: n,
  onChange: a,
  size: o = "md",
  variant: r = "filled",
  activeBackground: l,
  activeColor: s,
  activeBorderColor: c
}) {
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [pe.control, pe[o], r === "outline" ? pe.outline : ""].filter(Boolean).join(" "),
      role: "tablist"
    },
    t.map((i) => {
      const u = i.value === n, d = u ? {
        ...l !== void 0 ? { background: l } : {},
        ...s !== void 0 ? { color: s } : {},
        ...c !== void 0 ? { borderColor: c } : {}
      } : void 0;
      return /* @__PURE__ */ e.createElement(
        "button",
        {
          key: i.value,
          type: "button",
          role: "tab",
          "aria-selected": u,
          className: [pe.option, u ? pe.active : "", r === "outline" ? pe.outlineOption : ""].filter(Boolean).join(" "),
          style: d,
          onClick: () => a(i.value)
        },
        i.dot && /* @__PURE__ */ e.createElement("span", { className: pe.dot, style: { backgroundColor: i.dot } }),
        /* @__PURE__ */ e.createElement("span", { className: pe.label }, i.label),
        typeof i.count == "number" && /* @__PURE__ */ e.createElement("span", { className: pe.count }, i.count)
      );
    })
  );
}
const As = "_chip_8jgxm_1", js = "_clickable_8jgxm_14", Fs = "_suggested_8jgxm_23", Ms = "_readonly_8jgxm_33", Ds = "_plusIcon_8jgxm_39", Is = "_label_8jgxm_45", Rs = "_removeButton_8jgxm_50", je = {
  chip: As,
  clickable: js,
  default: "_default_8jgxm_18",
  suggested: Fs,
  readonly: Ms,
  plusIcon: Ds,
  label: Is,
  removeButton: Rs
};
function up({
  label: t,
  variant: n = "default",
  onRemove: a,
  onClick: o,
  background: r,
  textColor: l,
  borderColor: s
}) {
  const c = [je.chip, je[n], o ? je.clickable : ""].filter(Boolean).join(" "), u = r !== void 0 || l !== void 0 || s !== void 0 ? {
    ...r !== void 0 ? { background: r } : {},
    ...l !== void 0 ? { color: l } : {},
    ...s !== void 0 ? { borderColor: s } : {}
  } : {}, d = n !== "readonly" && !!a, _ = /* @__PURE__ */ e.createElement(e.Fragment, null, n === "suggested" && /* @__PURE__ */ e.createElement("span", { className: je.plusIcon, "aria-hidden": "true" }, "+"), /* @__PURE__ */ e.createElement("span", { className: je.label }, t), d && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: je.removeButton,
      "aria-label": `remove ${t}`,
      onClick: (p) => {
        p.stopPropagation(), a == null || a();
      }
    },
    /* @__PURE__ */ e.createElement("svg", { width: "10", height: "10", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.5", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M18 6L6 18" }), /* @__PURE__ */ e.createElement("path", { d: "M6 6l12 12" }))
  ));
  return o ? /* @__PURE__ */ e.createElement(
    "div",
    {
      role: "button",
      tabIndex: 0,
      className: c,
      style: u,
      onClick: o,
      onKeyDown: (p) => {
        (p.key === "Enter" || p.key === " ") && (p.preventDefault(), o());
      }
    },
    _
  ) : /* @__PURE__ */ e.createElement("span", { className: c, style: u }, _);
}
const Ts = "_wrapper_15dm4_1", qs = "_disabled_15dm4_8", zs = "_track_15dm4_13", Ps = "_checked_15dm4_30", Xs = "_thumb_15dm4_34", Os = "_label_15dm4_50", Fe = {
  wrapper: Ts,
  disabled: qs,
  track: zs,
  checked: Ps,
  thumb: Xs,
  label: Os
};
function mp({
  checked: t,
  onChange: n,
  labelOn: a,
  labelOff: o,
  disabled: r = !1,
  color: l
}) {
  const s = t ? a : o;
  return /* @__PURE__ */ e.createElement("label", { className: [Fe.wrapper, r ? Fe.disabled : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      role: "switch",
      "aria-checked": t,
      disabled: r,
      className: [Fe.track, t ? Fe.checked : ""].filter(Boolean).join(" "),
      style: t && l !== void 0 ? { background: l } : void 0,
      onClick: () => !r && n(!t)
    },
    /* @__PURE__ */ e.createElement("span", { className: Fe.thumb })
  ), s && /* @__PURE__ */ e.createElement("span", { className: Fe.label }, s));
}
const Ws = "_card_1uh3t_1", Gs = "_active_1uh3t_24", Ks = "_iconChip_1uh3t_29", Hs = "_body_1uh3t_41", Us = "_label_1uh3t_48", Ys = "_description_1uh3t_54", Me = {
  card: Ws,
  active: Gs,
  iconChip: Ks,
  body: Hs,
  label: Us,
  description: Ys
};
function dp(t) {
  const { icon: n, label: a, description: o, active: r = !1, onClick: l } = t;
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${Me.card} ${r ? Me.active : ""}`,
      onClick: l,
      "aria-pressed": r
    },
    /* @__PURE__ */ e.createElement("span", { className: Me.iconChip }, n),
    /* @__PURE__ */ e.createElement("span", { className: Me.body }, /* @__PURE__ */ e.createElement("span", { className: Me.label }, a), o && /* @__PURE__ */ e.createElement("span", { className: Me.description }, o))
  );
}
const Vs = "_breadcrumb_zkol9_1", Js = "_list_zkol9_6", Zs = "_item_zkol9_16", Qs = "_link_zkol9_22", ec = "_plain_zkol9_43", tc = "_current_zkol9_48", nc = "_separator_zkol9_54", xe = {
  breadcrumb: Vs,
  list: Js,
  item: Zs,
  link: Qs,
  plain: ec,
  current: tc,
  separator: nc
};
function _p(t) {
  const { items: n, separator: a = "/", textColor: o, hoverColor: r, currentColor: l } = t, s = {
    ...o !== void 0 ? { "--ax-bc-text": o } : {},
    ...r !== void 0 ? { "--ax-bc-hover": r } : {},
    ...l !== void 0 ? { "--ax-bc-current": l } : {}
  };
  return /* @__PURE__ */ e.createElement("nav", { className: xe.breadcrumb, "aria-label": "breadcrumb", style: s }, /* @__PURE__ */ e.createElement("ol", { className: xe.list }, n.map((c, i) => {
    const u = i === n.length - 1;
    return /* @__PURE__ */ e.createElement("li", { key: i, className: xe.item }, u ? /* @__PURE__ */ e.createElement("span", { className: xe.current, "aria-current": "page" }, c.label) : c.onClick ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: xe.link,
        onClick: c.onClick
      },
      c.label
    ) : /* @__PURE__ */ e.createElement("span", { className: xe.plain }, c.label), !u && /* @__PURE__ */ e.createElement("span", { className: xe.separator, "aria-hidden": "true" }, a));
  })));
}
const ac = "_treeItem_1ouqz_1", oc = "_active_1ouqz_18", rc = "_chevron_1ouqz_28", lc = "_chevronExpanded_1ouqz_48", sc = "_chevronSpacer_1ouqz_52", cc = "_icon_1ouqz_57", ic = "_label_1ouqz_69", uc = "_count_1ouqz_76", mc = "_dark_1ouqz_86", fe = {
  treeItem: ac,
  active: oc,
  chevron: rc,
  chevronExpanded: lc,
  chevronSpacer: sc,
  icon: cc,
  label: ic,
  count: uc,
  dark: mc
};
function pp(t) {
  const {
    icon: n,
    label: a,
    count: o,
    indent: r = 0,
    active: l = !1,
    expandable: s = !1,
    expanded: c = !1,
    theme: i = "light",
    onToggleExpand: u,
    onClick: d
  } = t, _ = (b) => {
    b.stopPropagation(), u == null || u();
  }, p = i === "dark" ? fe.dark : "";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: `${fe.treeItem} ${p} ${l ? fe.active : ""}`,
      style: { paddingLeft: 12 + r * 16 },
      onClick: d,
      role: "treeitem",
      "aria-selected": l,
      "aria-expanded": s ? c : void 0
    },
    s ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: `${fe.chevron} ${c ? fe.chevronExpanded : ""}`,
        onClick: _,
        "aria-label": c ? "Collapse" : "Expand"
      },
      /* @__PURE__ */ e.createElement("svg", { width: "10", height: "10", viewBox: "0 0 10 10", fill: "none" }, /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M3 1.5L7 5L3 8.5",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ))
    ) : /* @__PURE__ */ e.createElement("span", { className: fe.chevronSpacer }),
    n && /* @__PURE__ */ e.createElement("span", { className: fe.icon }, n),
    /* @__PURE__ */ e.createElement("span", { className: fe.label }, a),
    typeof o == "number" && /* @__PURE__ */ e.createElement("span", { className: fe.count }, o)
  );
}
const dc = "_backdrop_gstyy_1", _c = "_panel_gstyy_9", pc = "_right_gstyy_21", fc = "_left_gstyy_27", bc = "_header_gstyy_51", hc = "_icon_gstyy_59", Ec = "_titleGroup_gstyy_66", yc = "_kicker_gstyy_71", gc = "_title_gstyy_66", vc = "_subtitle_gstyy_87", kc = "_closeButton_gstyy_93", Nc = "_body_gstyy_115", wc = "_footer_gstyy_123", Z = {
  backdrop: dc,
  panel: _c,
  right: pc,
  left: fc,
  header: bc,
  icon: hc,
  titleGroup: Ec,
  kicker: yc,
  title: gc,
  subtitle: vc,
  closeButton: kc,
  body: Nc,
  footer: wc
};
function fp({
  open: t,
  onClose: n,
  icon: a,
  kicker: o,
  title: r,
  titleSize: l,
  titleWeight: s,
  subtitle: c,
  footer: i,
  children: u,
  side: d = "right",
  headerBackground: _,
  topOffset: p
}) {
  if (!t)
    return null;
  const b = [Z.panel, d === "left" ? Z.left : Z.right].filter(Boolean).join(" "), f = {
    ...l !== void 0 ? { fontSize: l } : {},
    ...s !== void 0 ? { fontWeight: s } : {}
  }, m = p !== void 0 ? { top: p, height: `calc(100vh - ${p}px)` } : void 0;
  return /* @__PURE__ */ e.createElement("div", { className: Z.backdrop, onClick: n }, /* @__PURE__ */ e.createElement("div", { className: b, style: m, onClick: (h) => h.stopPropagation() }, /* @__PURE__ */ e.createElement("div", { className: Z.header, style: _ !== void 0 ? { background: _ } : void 0 }, a && /* @__PURE__ */ e.createElement("span", { className: Z.icon }, a), /* @__PURE__ */ e.createElement("div", { className: Z.titleGroup }, o && /* @__PURE__ */ e.createElement("p", { className: Z.kicker }, o), /* @__PURE__ */ e.createElement("h2", { className: Z.title, style: f }, r), c && /* @__PURE__ */ e.createElement("p", { className: Z.subtitle }, c)), /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: Z.closeButton,
      onClick: n,
      "aria-label": "닫기"
    },
    "×"
  )), /* @__PURE__ */ e.createElement("div", { className: Z.body }, u), i && /* @__PURE__ */ e.createElement("div", { className: Z.footer }, i)));
}
const $c = "_backdrop_6kso7_1", xc = "_menu_6kso7_8", Cc = "_alignRight_6kso7_24", Bc = "_alignLeft_6kso7_28", Sc = "_item_6kso7_32", Lc = "_itemIcon_6kso7_50", Ac = "_itemText_6kso7_59", jc = "_itemLabel_6kso7_66", Fc = "_itemDescription_6kso7_72", Mc = "_danger_6kso7_77", le = {
  backdrop: $c,
  menu: xc,
  alignRight: Cc,
  alignLeft: Bc,
  item: Sc,
  itemIcon: Lc,
  itemText: Ac,
  itemLabel: jc,
  itemDescription: Fc,
  danger: Mc
};
function bp({
  open: t,
  onClose: n,
  items: a,
  anchor: o = "right"
}) {
  if (!t)
    return null;
  const r = [le.menu, o === "left" ? le.alignLeft : le.alignRight].filter(Boolean).join(" "), l = (s) => {
    s.onClick(), n();
  };
  return /* @__PURE__ */ e.createElement(Ht, null, /* @__PURE__ */ e.createElement("div", { className: le.backdrop, onClick: n }), /* @__PURE__ */ e.createElement("div", { className: r, onClick: (s) => s.stopPropagation() }, a.map((s, c) => {
    const i = [le.item, s.danger ? le.danger : ""].filter(Boolean).join(" ");
    return /* @__PURE__ */ e.createElement(
      "button",
      {
        key: c,
        type: "button",
        className: i,
        onClick: () => l(s)
      },
      s.icon && /* @__PURE__ */ e.createElement("span", { className: le.itemIcon }, s.icon),
      /* @__PURE__ */ e.createElement("span", { className: le.itemText }, /* @__PURE__ */ e.createElement("span", { className: le.itemLabel }, s.label), s.description && /* @__PURE__ */ e.createElement("span", { className: le.itemDescription }, s.description))
    );
  })));
}
const Dc = "_backdrop_3pc9i_1", Ic = "_card_3pc9i_12", Rc = "_header_3pc9i_23", Tc = "_icon_3pc9i_31", qc = "_titleGroup_3pc9i_38", zc = "_title_3pc9i_38", Pc = "_subtitle_3pc9i_50", Xc = "_closeButton_3pc9i_56", Oc = "_body_3pc9i_78", Wc = "_footer_3pc9i_85", se = {
  backdrop: Dc,
  card: Ic,
  header: Rc,
  icon: Tc,
  titleGroup: qc,
  title: zc,
  subtitle: Pc,
  closeButton: Xc,
  body: Oc,
  footer: Wc
};
function hp({
  open: t,
  onClose: n,
  icon: a,
  title: o,
  subtitle: r,
  footer: l,
  width: s = 480,
  children: c
}) {
  if (!t)
    return null;
  const i = typeof s == "number" ? `${s}px` : s;
  return /* @__PURE__ */ e.createElement("div", { className: se.backdrop, onClick: n }, /* @__PURE__ */ e.createElement(
    "div",
    {
      className: se.card,
      style: { width: i },
      onClick: (u) => u.stopPropagation()
    },
    /* @__PURE__ */ e.createElement("div", { className: se.header }, a && /* @__PURE__ */ e.createElement("span", { className: se.icon }, a), /* @__PURE__ */ e.createElement("div", { className: se.titleGroup }, /* @__PURE__ */ e.createElement("h2", { className: se.title }, o), r && /* @__PURE__ */ e.createElement("p", { className: se.subtitle }, r)), /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: se.closeButton,
        onClick: n,
        "aria-label": "닫기"
      },
      "×"
    )),
    /* @__PURE__ */ e.createElement("div", { className: se.body }, c),
    l && /* @__PURE__ */ e.createElement("div", { className: se.footer }, l)
  ));
}
const Gc = "_page_1f94v_5", Kc = "_inner_1f94v_18", Mt = {
  page: Gc,
  inner: Kc
};
function Ep({
  gnbHeight: t = 64,
  minWidth: n = 1024,
  className: a = "",
  style: o,
  children: r
}) {
  return /* @__PURE__ */ e.createElement(
    "main",
    {
      className: [Mt.page, "axe-page", a].filter(Boolean).join(" "),
      style: { height: `calc(100vh - ${t}px)`, ...o }
    },
    /* @__PURE__ */ e.createElement("div", { className: Mt.inner, style: { minWidth: n } }, r)
  );
}
const Hc = "_bar_j0oph_1", Uc = "_menu_j0oph_9", Yc = "_title_j0oph_19", Vc = "_info_j0oph_21", Jc = "_badge_j0oph_29", Zc = "_badge_muted_j0oph_30", Qc = "_badge_ok_j0oph_31", ei = "_badge_warn_j0oph_32", ti = "_meta_j0oph_34", ni = "_actions_j0oph_18", ai = "_notice_j0oph_48", oi = "_notice_info_j0oph_53", ri = "_notice_ok_j0oph_54", li = "_notice_err_j0oph_55", ce = {
  bar: Hc,
  menu: Uc,
  title: Yc,
  info: Vc,
  badge: Jc,
  badge_muted: Zc,
  badge_ok: Qc,
  badge_warn: ei,
  meta: ti,
  actions: ni,
  notice: ai,
  notice_info: oi,
  notice_ok: ri,
  notice_err: li
};
function yp({
  title: t,
  onMenu: n,
  info: a,
  badge: o,
  meta: r,
  notice: l,
  children: s
}) {
  var c;
  return /* @__PURE__ */ e.createElement("header", { className: ce.bar }, n && /* @__PURE__ */ e.createElement("button", { type: "button", className: ce.menu, "aria-label": "메뉴", onClick: n }, "☰"), /* @__PURE__ */ e.createElement("h1", { className: ce.title }, t), a && /* @__PURE__ */ e.createElement("span", { className: ce.info, title: a }, "i"), (Array.isArray(o) ? o : [o]).filter(Boolean).map((i, u) => {
    var d;
    return /* @__PURE__ */ e.createElement("span", { key: u, className: [ce.badge, ce[`badge_${(d = i.tone) != null ? d : "muted"}`]].join(" ") }, i.label);
  }), r && /* @__PURE__ */ e.createElement("span", { className: ce.meta }, r), /* @__PURE__ */ e.createElement("span", { className: ce.actions }, l && l.text && /* @__PURE__ */ e.createElement("span", { className: [ce.notice, ce[`notice_${(c = l.tone) != null ? c : "info"}`]].join(" "), role: "status" }, l.text), s));
}
const si = "_btn_1oonv_1", ci = "_primary_1oonv_18", ii = "_dark_1oonv_20", ui = "_danger_1oonv_22", mi = "_soon_1oonv_26", di = "_soonTag_1oonv_27", _i = "_kbd_1oonv_42", pi = "_iconBtn_1oonv_45", De = {
  btn: si,
  primary: ci,
  dark: ii,
  danger: ui,
  soon: mi,
  soonTag: di,
  kbd: _i,
  iconBtn: pi
}, _t = En(function({
  variant: n = "default",
  kbd: a,
  soon: o,
  children: r,
  className: l = "",
  type: s = "button",
  onClick: c,
  title: i,
  ...u
}, d) {
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      ref: d,
      type: s,
      className: [De.btn, De[n], o ? De.soon : "", l].filter(Boolean).join(" "),
      "aria-disabled": o ? !0 : void 0,
      title: o != null ? o : i,
      onClick: o ? (_) => _.preventDefault() : c,
      ...u
    },
    r,
    a && /* @__PURE__ */ e.createElement("kbd", { className: De.kbd }, a),
    o && /* @__PURE__ */ e.createElement("em", { className: De.soonTag }, "준비 중")
  );
});
function gp({ label: t, children: n, className: a = "", type: o = "button", ...r }) {
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: o,
      className: [De.iconBtn, a].filter(Boolean).join(" "),
      "aria-label": t,
      title: t,
      ...r
    },
    n
  );
}
const fi = {
  print: /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M7 8V4h10v4" }), /* @__PURE__ */ e.createElement("path", { d: "M7 16H5.5A2.5 2.5 0 0 1 3 13.5v-3A2.5 2.5 0 0 1 5.5 8h13A2.5 2.5 0 0 1 21 10.5v3a2.5 2.5 0 0 1-2.5 2.5H17" }), /* @__PURE__ */ e.createElement("rect", { x: "7", y: "13", width: "10", height: "7", rx: "1" })),
  trash: /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M4 7h16" }), /* @__PURE__ */ e.createElement("path", { d: "M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" }), /* @__PURE__ */ e.createElement("path", { d: "M6.2 7l.9 12.1A2 2 0 0 0 9.1 21h5.8a2 2 0 0 0 2-1.9L17.8 7" }), /* @__PURE__ */ e.createElement("path", { d: "M10 11v6M14 11v6" }))
}, bi = {
  panel: "▣",
  "chevron-open": "∨",
  "chevron-closed": "＞",
  collapse: "◀",
  expand: "▶",
  mail: "✉",
  chat: "💬",
  save: "💾",
  close: "✕"
};
function vp({ name: t, className: n }) {
  return /* @__PURE__ */ e.createElement("span", { className: n, "aria-hidden": "true" }, bi[t]);
}
function kp({ name: t, size: n = 15, className: a }) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      className: a,
      width: n,
      height: n,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      style: { verticalAlign: "-2px" },
      "aria-hidden": "true"
    },
    fi[t]
  );
}
const hi = "_underline_145xy_2", Ei = "_active_145xy_24", yi = "_segmented_145xy_33", ct = {
  underline: hi,
  active: Ei,
  segmented: yi
};
function Np({
  items: t,
  value: n,
  onChange: a,
  variant: o = "underline",
  className: r = "",
  "aria-label": l
}) {
  return /* @__PURE__ */ e.createElement(
    "nav",
    {
      className: [o === "segmented" ? ct.segmented : ct.underline, r].filter(Boolean).join(" "),
      role: "tablist",
      "aria-label": l
    },
    t.map((s) => /* @__PURE__ */ e.createElement(
      "button",
      {
        key: s.key,
        type: "button",
        role: "tab",
        "aria-selected": s.key === n,
        className: s.key === n ? ct.active : "",
        onClick: () => a(s.key)
      },
      s.label
    ))
  );
}
const gi = "_bar_g00bz_1", vi = "_actions_g00bz_17", ki = "_field_g00bz_24", Ni = "_fieldLabel_g00bz_25", wi = "_readout_g00bz_36", $i = "_search_g00bz_47", xi = "_detail_g00bz_60", Ci = "_pill_g00bz_72", Bi = "_hint_g00bz_83", he = {
  bar: gi,
  actions: vi,
  field: ki,
  fieldLabel: Ni,
  readout: wi,
  search: $i,
  detail: xi,
  pill: Ci,
  hint: Bi
};
function wp({
  children: t,
  onSearch: n,
  searchLabel: a = "조회",
  detailSearch: o = !1,
  onDetailSearch: r,
  detailLabel: l = "상세검색",
  trailing: s
}) {
  return /* @__PURE__ */ e.createElement("section", { className: he.bar }, t, /* @__PURE__ */ e.createElement("span", { className: he.actions }, s, o && /* @__PURE__ */ e.createElement("button", { type: "button", className: he.detail, onClick: r }, "⌕ ", l), n && /* @__PURE__ */ e.createElement("button", { type: "button", className: he.search, onClick: n }, "⌕ ", a)));
}
function Si({ label: t, children: n }) {
  return /* @__PURE__ */ e.createElement("label", { className: he.field }, /* @__PURE__ */ e.createElement("span", { className: he.fieldLabel }, t), n);
}
function $p({ children: t }) {
  return /* @__PURE__ */ e.createElement("span", { className: he.readout }, t);
}
function xp({ children: t }) {
  return /* @__PURE__ */ e.createElement("span", { className: he.pill, role: "status" }, t);
}
function Cp({ children: t }) {
  return /* @__PURE__ */ e.createElement("span", { className: he.hint }, t);
}
function Li(t) {
  return `${t.gisu}기 (${t.startDa} ~ ${t.endDa})${t.closeYn ? " · 마감" : ""}`;
}
function Bp({ rows: t, value: n, onChange: a, disabled: o, label: r = "기수" }) {
  return /* @__PURE__ */ e.createElement(Si, { label: r }, /* @__PURE__ */ e.createElement(
    "select",
    {
      value: n != null ? n : "",
      "aria-label": r,
      disabled: o,
      onChange: (l) => a(Number(l.target.value))
    },
    t.map((l) => /* @__PURE__ */ e.createElement("option", { key: l.gisu, value: l.gisu }, Li(l)))
  ));
}
class nn {
  constructor(n, a) {
    this._resizeObserver = null, this.initializeResizeObserver = () => {
      this._resizeObserver = new ResizeObserver((o) => {
        try {
          for (const r of o) {
            const l = r.borderBoxSize[0];
            this._callback({ width: l.inlineSize, height: l.blockSize }, r);
          }
        } catch (r) {
          console.error(r);
        }
      }), this._resizeObserver.observe(this._element);
    }, this.refresh = () => {
    }, this.detach = () => {
      this._resizeObserver && this._resizeObserver.disconnect();
    }, this.reset = () => {
    }, this._element = n, this._callback = a, this.initializeResizeObserver();
  }
}
const Ai = "_card_1lfyb_2", ji = "_grow_1lfyb_16", Fi = "_head_1lfyb_18", Mi = "_title_1lfyb_27", Di = "_trailing_1lfyb_28", Ii = "_scroll_1lfyb_9", Ri = "_foot_1lfyb_44", Ti = "_strip_1lfyb_46", qi = "_spacer_1lfyb_47", zi = "_table_1lfyb_49", Pi = "_fixed_1lfyb_50", Xi = "_fz_1lfyb_64", Oi = "_fzEdge_1lfyb_76", Wi = "_frozen_1lfyb_83", Gi = "_statusCell_1lfyb_192", Ki = "_status_1lfyb_192", Hi = "_st_error_1lfyb_200", Ui = "_stIcon_1lfyb_201", Yi = "_spin_1lfyb_207", Vi = "_axeSpin_1lfyb_1", Ji = "_busy_1lfyb_217", Zi = "_statusRow_1lfyb_219", Qi = "_busyBar_1lfyb_220", eu = "_axeBusy_1lfyb_1", T = {
  card: Ai,
  grow: ji,
  head: Fi,
  title: Mi,
  trailing: Di,
  scroll: Ii,
  foot: Ri,
  strip: Ti,
  spacer: qi,
  table: zi,
  fixed: Pi,
  fz: Xi,
  fzEdge: Oi,
  frozen: Wi,
  statusCell: Gi,
  status: Ki,
  st_error: Hi,
  stIcon: Ui,
  spin: Yi,
  axeSpin: Vi,
  busy: Ji,
  statusRow: Zi,
  busyBar: Qi,
  axeBusy: eu
};
function Dt({ cols: t }) {
  return !t || !t.length ? null : /* @__PURE__ */ e.createElement("colgroup", null, t.map((n, a) => /* @__PURE__ */ e.createElement("col", { key: a, style: n == null ? void 0 : { width: n } })));
}
const It = /* @__PURE__ */ new Set();
function tu(t) {
  var o;
  if (typeof process == "undefined" || ((o = process.env) == null ? void 0 : o.NODE_ENV) === "production") return;
  const n = [];
  if (t.querySelectorAll("td.axe-money").forEach((r) => {
    var l, s;
    r.scrollWidth > r.clientWidth + 1 && n.push((s = (l = r.textContent) == null ? void 0 : l.trim()) != null ? s : "");
  }), !n.length) return;
  const a = n.slice(0, 5).join("|");
  It.has(a) || (It.add(a), console.warn(
    `[AXErpGrid] 금액 셀 ${n.length}개가 컬럼 폭을 넘어 말줄임됩니다 — cols 를 moneyColWidth() 로 계산하세요.`,
    n.slice(0, 5)
  ));
}
function Rt(t, n, a) {
  if (!t) return;
  const o = /* @__PURE__ */ new Map();
  for (const r of Array.from(t.rows)) {
    o.forEach((s, c) => {
      s <= 1 ? o.delete(c) : o.set(c, s - 1);
    });
    let l = 0;
    for (const s of Array.from(r.cells)) {
      for (; o.has(l); ) l += 1;
      const c = s.colSpan || 1, i = n > 0 && l + c <= n;
      if (s.classList.toggle(T.fz, i), s.classList.toggle(T.fzEdge, i && l + c === n), s.style.left = i ? `${a[l]}px` : "", s.rowSpan > 1) for (let u = l; u < l + c; u += 1) o.set(u, s.rowSpan);
      l += c;
    }
  }
}
function Sp({
  cols: t,
  footer: n,
  title: a,
  trailing: o,
  grow: r,
  fixed: l,
  stickyCols: s = 0,
  busy: c,
  className: i = "",
  children: u
}) {
  const d = l || t !== void 0 && t.length > 0, { stick: _, offsets: p } = Ne(() => {
    const k = Math.max(Math.trunc(s), 0), x = [];
    if (k === 0 || !t) return { stick: 0, offsets: x };
    let I = 0, C = 0;
    for (let L = 0; L < k; L += 1) {
      const j = t[L];
      if (typeof j != "number") break;
      x.push(I), I += j, C += 1;
    }
    return { stick: C, offsets: x };
  }, [t, s]), b = [T.table, d ? T.fixed : "", _ > 0 ? T.frozen : ""].filter(Boolean).join(" "), f = F(null), m = F(null), h = F(null), v = F(null), w = F(0), E = () => {
    const k = f.current, x = h.current, I = v.current;
    if (!k || !x || !I) return;
    const C = k.scrollWidth;
    I.style.width = C + "px", x.style.display = C > k.clientWidth + 1 ? "" : "none";
    const L = k.offsetWidth - k.clientWidth;
    x.style.paddingRight = L + "px", m.current && (m.current.style.paddingRight = L + "px"), tu(k);
  };
  K(() => {
    const k = f.current;
    if (!k) return;
    const x = new nn(k, E);
    return () => x.detach();
  }, []), Ut(() => {
    var k, x, I, C;
    (_ > 0 || w.current > 0) && (Rt((x = (k = f.current) == null ? void 0 : k.querySelector("table")) != null ? x : null, _, p), Rt((C = (I = m.current) == null ? void 0 : I.querySelector("table")) != null ? C : null, _, p)), w.current = _, E();
  });
  const N = (k) => {
    const x = k.target.scrollLeft;
    f.current && (f.current.scrollLeft = x), m.current && (m.current.scrollLeft = x);
  }, $ = (k) => {
    const x = k.target.scrollLeft;
    m.current && (m.current.scrollLeft = x), h.current && (h.current.scrollLeft = x);
  };
  return /* @__PURE__ */ e.createElement("div", { className: [T.card, r ? T.grow : "", c ? T.busy : "", i].filter(Boolean).join(" ") }, c && /* @__PURE__ */ e.createElement("div", { className: T.busyBar, "aria-hidden": "true" }), (a !== void 0 || o !== void 0) && /* @__PURE__ */ e.createElement("header", { className: T.head }, /* @__PURE__ */ e.createElement("span", { className: T.title }, a), o && /* @__PURE__ */ e.createElement("span", { className: T.trailing }, o)), /* @__PURE__ */ e.createElement("div", { className: T.scroll, ref: f, onScroll: $ }, /* @__PURE__ */ e.createElement("table", { className: b, "aria-busy": c || void 0 }, /* @__PURE__ */ e.createElement(Dt, { cols: t }), u)), n && /* @__PURE__ */ e.createElement("div", { className: T.foot, ref: m }, /* @__PURE__ */ e.createElement("table", { className: b }, /* @__PURE__ */ e.createElement(Dt, { cols: t }), /* @__PURE__ */ e.createElement("tbody", null, n))), /* @__PURE__ */ e.createElement("div", { className: T.strip, ref: h, onScroll: N }, /* @__PURE__ */ e.createElement("div", { ref: v, className: T.spacer })));
}
const nu = 7.09, au = 3.88, ou = 4.46, ru = 16, lu = 2;
function su(t, n = {}) {
  var l;
  const a = Math.max(1, t), o = Math.floor((a - 1) / 3), r = a * nu + o * au + (n.negative ? ou : 0) + ru + lu;
  return Math.max(Math.ceil(r), (l = n.min) != null ? l : 0);
}
function Lp(t, n = {}) {
  var r, l;
  let a = 0, o = (r = n.negative) != null ? r : !1;
  for (const s of t) {
    if (s == null || s === "") continue;
    const c = typeof s == "number" ? s : Number(String(s).replace(/[^\d.-]/g, ""));
    if (!Number.isFinite(c)) continue;
    c < 0 && (o = !0);
    const i = Math.floor(Math.abs(c)).toString().length;
    i > a && (a = i);
  }
  return a === 0 ? Math.max((l = n.min) != null ? l : 96, 96) : su(a, { ...n, negative: o });
}
function Ap(t) {
  const n = document.createElement("span");
  n.style.cssText = "position:absolute;visibility:hidden;white-space:nowrap", t.appendChild(n);
  const a = (s) => (n.textContent = s, n.getBoundingClientRect().width), o = a("000000000000"), r = a("000,000,000,000"), l = a("-000,000,000,000");
  return n.remove(), { digit: o / 12, comma: (r - o) / 3, minus: l - r };
}
function jp({
  colSpan: t,
  loading: n,
  error: a,
  count: o,
  empty: r = "조회 결과가 없습니다",
  idle: l = "조회조건을 정하고 조회하세요",
  loadingText: s = "조회 중…",
  className: c = ""
}) {
  const i = a != null && a !== !1 && a !== "", u = o == null || o === 0, d = a === !0 ? "조회하지 못했습니다 — 위 오류 안내를 확인한 뒤 다시 조회하세요" : a;
  let _;
  if (i) _ = "error";
  else if (n && u) _ = "loading";
  else if (o == null) {
    if (l === null) return null;
    _ = "idle";
  } else if (o === 0) _ = "empty";
  else return null;
  const p = /* @__PURE__ */ e.createElement(e.Fragment, null, _ === "loading" && /* @__PURE__ */ e.createElement("span", { className: T.spin, "aria-hidden": "true" }), _ === "error" && /* @__PURE__ */ e.createElement("span", { className: T.stIcon, "aria-hidden": "true" }, "!"), /* @__PURE__ */ e.createElement("span", null, _ === "error" ? d : _ === "loading" ? s : _ === "idle" ? l : r)), b = /* @__PURE__ */ e.createElement("div", { className: [T.status, T[`st_${_}`]].join(" "), role: "status" }, p);
  return t === void 0 ? /* @__PURE__ */ e.createElement("div", { className: c || void 0, "data-state": _ }, b) : /* @__PURE__ */ e.createElement("tr", { className: [T.statusRow, c].filter(Boolean).join(" "), "data-state": _ }, /* @__PURE__ */ e.createElement("td", { colSpan: t, className: T.statusCell }, b));
}
const cu = "_card_1xyfv_1", iu = "_accent_1xyfv_8", uu = "_grow_1xyfv_9", mu = "_head_1xyfv_11", du = "_title_1xyfv_20", _u = "_trailing_1xyfv_21", pu = "_summary_1xyfv_24", fu = "_sumHead_1xyfv_25", bu = "_sumTotal_1xyfv_34", hu = "_tone_warn_1xyfv_35", Eu = "_tone_ok_1xyfv_36", yu = "_sumList_1xyfv_38", gu = "_sumEm_1xyfv_47", vu = "_sumFoot_1xyfv_49", ku = "_sumNote_1xyfv_58", W = {
  card: cu,
  accent: iu,
  grow: uu,
  head: mu,
  title: du,
  trailing: _u,
  summary: pu,
  sumHead: fu,
  sumTotal: bu,
  tone_warn: hu,
  tone_ok: Eu,
  sumList: yu,
  sumEm: gu,
  sumFoot: vu,
  sumNote: ku
};
function Fp({
  title: t,
  trailing: n,
  accent: a,
  grow: o,
  className: r = "",
  children: l
}) {
  return /* @__PURE__ */ e.createElement(
    "section",
    {
      className: [W.card, a ? W.accent : "", o ? W.grow : "", r].filter(Boolean).join(" ")
    },
    t !== void 0 && /* @__PURE__ */ e.createElement("header", { className: W.head }, /* @__PURE__ */ e.createElement("span", { className: W.title }, t), n && /* @__PURE__ */ e.createElement("span", { className: W.trailing }, n)),
    l
  );
}
function Mp({
  title: t,
  total: n,
  items: a,
  footerLabel: o,
  footerValue: r,
  note: l,
  tone: s = "default",
  children: c
}) {
  return /* @__PURE__ */ e.createElement("section", { className: [W.card, W.accent, W.summary, W[`tone_${s}`]].join(" ") }, /* @__PURE__ */ e.createElement("header", { className: W.sumHead }, /* @__PURE__ */ e.createElement("span", null, t), n !== void 0 && /* @__PURE__ */ e.createElement("strong", { className: W.sumTotal }, n)), /* @__PURE__ */ e.createElement("ul", { className: W.sumList }, a.map((i, u) => {
    var d;
    return /* @__PURE__ */ e.createElement("li", { key: (d = i.key) != null ? d : u, className: i.em ? W.sumEm : "" }, /* @__PURE__ */ e.createElement("span", null, i.label), /* @__PURE__ */ e.createElement("strong", null, i.value));
  })), c, o !== void 0 && /* @__PURE__ */ e.createElement("footer", { className: W.sumFoot }, /* @__PURE__ */ e.createElement("span", null, o), /* @__PURE__ */ e.createElement("strong", null, r)), l && /* @__PURE__ */ e.createElement("div", { className: W.sumNote }, l));
}
const Nu = "_orbitPortalRoot_177qv_2", wu = {
  orbitPortalRoot: Nu
};
class an extends Yt {
  constructor() {
    super(...arguments), this.getPortalRoot = () => {
      const n = this.props.portalClassName || wu.orbitPortalRoot, a = Array.from(document.body.childNodes).find((o) => o.className === n);
      if (!a) {
        const o = document.createElement("div");
        return o.className = n, document.body.appendChild(o), o;
      }
      return a;
    };
  }
  render() {
    return wn(this.props.children, this.getPortalRoot());
  }
}
const $u = "_root_qv0h6_1", xu = "_codeInput_qv0h6_3", Cu = "_pickBtn_qv0h6_6", Bu = "_popup_qv0h6_21", Su = "_popupHead_qv0h6_35", Lu = "_searchRow_qv0h6_45", Au = "_list_qv0h6_49", ju = "_current_qv0h6_58", Fu = "_empty_qv0h6_62", Mu = "_summaryBtn_qv0h6_70", Du = "_ov_qv0h6_91", Iu = "_modal_qv0h6_102", Ru = "_head_qv0h6_113", Tu = "_sub_qv0h6_121", qu = "_x_qv0h6_123", zu = "_body_qv0h6_140", Pu = "_chips_qv0h6_148", Xu = "_chip_qv0h6_148", Ou = "_chipOn_qv0h6_162", Wu = "_search_qv0h6_45", Gu = "_tbl_qv0h6_181", Ku = "_row_qv0h6_211", Hu = "_rowCursor_qv0h6_213", Uu = "_rowPicked_qv0h6_214", Yu = "_chk_qv0h6_216", Vu = "_tdLeft_qv0h6_217", Ju = "_tdCenter_qv0h6_218", Zu = "_emptyCell_qv0h6_220", Qu = "_stop_qv0h6_222", em = "_more_qv0h6_233", tm = "_pager_qv0h6_245", nm = "_note_qv0h6_258", am = "_foot_qv0h6_261", om = "_ghost_qv0h6_270", rm = "_primary_qv0h6_282", S = {
  root: $u,
  codeInput: xu,
  pickBtn: Cu,
  popup: Bu,
  popupHead: Su,
  searchRow: Lu,
  list: Au,
  current: ju,
  empty: Fu,
  summaryBtn: Mu,
  ov: Du,
  modal: Iu,
  head: Ru,
  sub: Tu,
  x: qu,
  body: zu,
  chips: Pu,
  chip: Xu,
  chipOn: Ou,
  search: Wu,
  tbl: Gu,
  row: Ku,
  rowCursor: Hu,
  rowPicked: Uu,
  chk: Yu,
  tdLeft: Vu,
  tdCenter: Ju,
  emptyCell: Zu,
  stop: Qu,
  more: em,
  pager: tm,
  note: nm,
  foot: am,
  ghost: om,
  primary: rm
};
function lm(t, n = "전체") {
  if (t.length === 0) return n;
  const a = `${t[0].cd}.${t[0].nm}`;
  return t.length === 1 ? a : `${a} 외 ${t.length - 1}건`;
}
const sm = 250;
function Dp({
  value: t = "",
  onChange: n,
  items: a,
  source: o,
  multiple: r = !1,
  selected: l,
  onConfirm: s,
  trigger: c,
  emptyLabel: i = "전체",
  open: u,
  onOpenChange: d,
  placeholder: _,
  title: p = "코드도움",
  variant: b,
  disabled: f,
  className: m = ""
}) {
  const h = o ? "source" : "static", v = b != null ? b : h === "source" ? "modal" : "anchor", w = c != null ? c : r ? "summary" : "input", [E, N] = y(!1), $ = u != null ? u : E, k = G(
    (A) => {
      u === void 0 && N(A), d && d(A);
    },
    [u, d]
  ), x = F(null), I = F(null), C = F(null), [L, j] = y(null), q = () => {
    if (!f) {
      if (v === "anchor") {
        const A = x.current;
        if (!A) return;
        const z = A.getBoundingClientRect(), H = 320, D = z.bottom + H > window.innerHeight ? Math.max(8, z.top - H - 4) : z.bottom + 4;
        j({ left: Math.min(z.left, window.innerWidth - 320), top: D });
      }
      k(!0);
    }
  }, R = G(() => k(!1), [k]);
  return /* @__PURE__ */ e.createElement("span", { ref: x, className: [S.root, m].filter(Boolean).join(" ") }, w === "input" && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    "input",
    {
      className: S.codeInput,
      value: t,
      placeholder: _,
      disabled: f,
      onChange: (A) => n && n(A.target.value.trim()),
      onKeyDown: (A) => {
        A.key === "F2" && (A.preventDefault(), q());
      },
      title: "F2: 코드도움"
    }
  ), /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: S.pickBtn,
      "aria-label": "코드도움 열기",
      disabled: f,
      onClick: q,
      tabIndex: -1
    },
    "⌕"
  )), w === "summary" && /* @__PURE__ */ e.createElement("button", { type: "button", className: S.summaryBtn, disabled: f, onClick: q }, /* @__PURE__ */ e.createElement("span", null, lm(l != null ? l : [], i)), /* @__PURE__ */ e.createElement("i", { "aria-hidden": "true" }, "⌕")), $ && h === "static" && v === "anchor" && L && /* @__PURE__ */ e.createElement(
    cm,
    {
      items: a != null ? a : [],
      value: t,
      title: p,
      popupRef: I,
      anchorRef: x,
      pos: L,
      onPick: (A) => {
        n && n(A.code, A), R();
      },
      onClose: R
    }
  ), $ && (h === "source" || v === "modal") && /* @__PURE__ */ e.createElement(
    um,
    {
      source: o,
      items: a,
      title: p,
      multiple: r,
      selected: l,
      searchRef: C,
      onConfirm: (A) => {
        s ? s(A) : A[0] && n && n(A[0].cd, { code: A[0].cd, name: A[0].nm }), R();
      },
      onClose: R
    }
  ));
}
function cm({
  items: t,
  value: n,
  title: a,
  popupRef: o,
  anchorRef: r,
  pos: l,
  onPick: s,
  onClose: c
}) {
  const [i, u] = y(""), d = Ne(() => {
    const _ = i.trim().toLowerCase();
    return _ ? t.filter(
      (p) => {
        var b;
        return p.code.toLowerCase().includes(_) || p.name.toLowerCase().includes(_) || ((b = p.sub) != null ? b : "").toLowerCase().includes(_);
      }
    ) : t;
  }, [t, i]);
  return K(() => {
    const _ = (b) => {
      const f = b.target;
      o.current && !o.current.contains(f) && r.current && !r.current.contains(f) && c();
    }, p = (b) => {
      b.key === "Escape" && c();
    };
    return document.addEventListener("mousedown", _), document.addEventListener("keydown", p), () => {
      document.removeEventListener("mousedown", _), document.removeEventListener("keydown", p);
    };
  }, [o, r, c]), /* @__PURE__ */ e.createElement(an, null, /* @__PURE__ */ e.createElement(
    "div",
    {
      ref: o,
      className: S.popup,
      style: { left: l.left, top: l.top },
      role: "dialog",
      "aria-label": "코드도움"
    },
    /* @__PURE__ */ e.createElement("header", { className: S.popupHead }, /* @__PURE__ */ e.createElement("strong", null, a), /* @__PURE__ */ e.createElement("button", { type: "button", "aria-label": "닫기", onClick: c }, "✕")),
    /* @__PURE__ */ e.createElement("div", { className: S.searchRow }, /* @__PURE__ */ e.createElement(
      "input",
      {
        autoFocus: !0,
        value: i,
        placeholder: "코드·명칭 검색",
        onChange: (_) => u(_.target.value),
        onKeyDown: (_) => {
          _.key === "Enter" && d.length && s(d[0]), _.key === "Escape" && c();
        }
      }
    )),
    /* @__PURE__ */ e.createElement("ul", { className: S.list }, d.map((_) => /* @__PURE__ */ e.createElement("li", { key: _.code }, /* @__PURE__ */ e.createElement("button", { type: "button", onClick: () => s(_), className: _.code === n ? S.current : "" }, /* @__PURE__ */ e.createElement("code", null, _.code), /* @__PURE__ */ e.createElement("span", null, _.name), _.sub && /* @__PURE__ */ e.createElement("small", null, _.sub)))), d.length === 0 && /* @__PURE__ */ e.createElement("li", { className: S.empty }, "검색 결과가 없습니다"))
  ));
}
function im(t, n) {
  const a = t.map((o) => ({ cd: o.code, nm: o.name, sub: o.sub }));
  return {
    key: "static",
    title: typeof n == "string" ? n : "코드도움",
    nameLabel: "명칭",
    fetch: ({ q: o }) => {
      const r = o.trim().toLowerCase();
      return r ? Promise.resolve({
        rows: a.filter(
          (l) => {
            var s;
            return l.cd.toLowerCase().includes(r) || l.nm.toLowerCase().includes(r) || String((s = l.sub) != null ? s : "").toLowerCase().includes(r);
          }
        )
      }) : Promise.resolve({ rows: a });
    }
  };
}
function um({
  source: t,
  items: n,
  title: a,
  multiple: o,
  selected: r,
  searchRef: l,
  onConfirm: s,
  onClose: c
}) {
  const i = Ne(() => im(n != null ? n : [], a), [n, a]), u = t != null ? t : i, [d, _] = y(""), [p, b] = y(null), [f, m] = y(0), [h, v] = y([]), [w, E] = y(!1), [N, $] = y(!1), [k, x] = y(null), [I, C] = y(0), [L, j] = y(/* @__PURE__ */ new Map()), q = F(u);
  q.current = u, K(() => {
    _(""), b(null), m(0), C(0), x(null), j(new Map((r != null ? r : []).map((X) => [X.cd, X])));
    const g = window.setTimeout(() => {
      l.current && l.current.focus();
    }, 30);
    return () => window.clearTimeout(g);
  }, [u.key]), K(() => {
    let g = !0;
    const X = () => {
      $(!0), q.current.fetch({ q: d.trim(), ty: p, page: f }).then((ge) => {
        var Nt;
        g && (v((Nt = ge.rows) != null ? Nt : []), E(!!ge.hasMore), x(null), C(0));
      }).catch((ge) => {
        g && (v([]), E(!1), x(ge instanceof Error ? ge.message : "코드도움 조회에 실패했습니다"));
      }).finally(() => {
        g && $(!1);
      });
    }, M = window.setTimeout(X, d.trim() ? sm : 0);
    return () => {
      g = !1, window.clearTimeout(M);
    };
  }, [u.key, d, p, f]);
  const R = Ne(() => {
    var X;
    const g = [
      { key: "cd", label: "Code", width: "96px", align: "center" },
      {
        key: "nm",
        label: u.nameLabel,
        align: "left",
        render: (M) => /* @__PURE__ */ e.createElement(e.Fragment, null, M.nm, M.useYn === !1 && /* @__PURE__ */ e.createElement("span", { className: S.stop }, "중단"))
      }
    ];
    return u.typeLabel && g.push({
      key: "__ty",
      label: "구분",
      width: "110px",
      align: "center",
      render: (M) => u.typeLabel ? u.typeLabel(M) : ""
    }), g.concat((X = u.extraColumns) != null ? X : []);
  }, [u]), A = G((g) => {
    j((X) => {
      const M = new Map(X);
      return M.has(g.cd) ? M.delete(g.cd) : M.set(g.cd, g), M;
    });
  }, []), z = G((g) => s([g]), [s]), H = G(() => s(Array.from(L.values())), [L, s]), D = h.length > 0 && h.every((g) => L.has(g.cd)), bn = () => {
    j((g) => {
      const X = new Map(g);
      return D ? h.forEach((M) => X.delete(M.cd)) : h.forEach((M) => X.set(M.cd, M)), X;
    });
  }, hn = (g) => {
    if (g.key === "Escape") {
      g.stopPropagation(), c();
      return;
    }
    if (g.key === "ArrowDown" || g.key === "ArrowUp") {
      g.preventDefault(), C((X) => Math.max(0, Math.min(h.length - 1, X + (g.key === "ArrowDown" ? 1 : -1))));
      return;
    }
    if (g.key === " " && o && h[I]) {
      g.preventDefault(), A(h[I]);
      return;
    }
    g.key === "Enter" && (g.preventDefault(), o ? H() : h[I] && z(h[I]));
  };
  return /* @__PURE__ */ e.createElement(an, null, /* @__PURE__ */ e.createElement("div", { className: S.ov, onClick: c }, /* @__PURE__ */ e.createElement(
    "div",
    {
      className: S.modal,
      role: "dialog",
      "aria-modal": "true",
      "aria-label": u.title,
      onClick: (g) => g.stopPropagation(),
      onKeyDown: hn
    },
    /* @__PURE__ */ e.createElement("div", { className: S.head }, /* @__PURE__ */ e.createElement("h2", null, u.title), o && /* @__PURE__ */ e.createElement("span", { className: S.sub }, "복수 선택 가능"), /* @__PURE__ */ e.createElement("button", { type: "button", className: S.x, onClick: c, "aria-label": "닫기" }, "×")),
    /* @__PURE__ */ e.createElement("div", { className: S.body }, u.filters && u.filters.length > 0 && /* @__PURE__ */ e.createElement("div", { className: S.chips }, /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: p === null ? `${S.chip} ${S.chipOn}` : S.chip,
        onClick: () => {
          b(null), m(0);
        }
      },
      "전체"
    ), u.filters.map((g) => /* @__PURE__ */ e.createElement(
      "button",
      {
        key: g.value,
        type: "button",
        className: p === g.value ? `${S.chip} ${S.chipOn}` : S.chip,
        onClick: () => {
          b(g.value), m(0);
        }
      },
      g.label
    ))), /* @__PURE__ */ e.createElement(
      "input",
      {
        ref: l,
        className: S.search,
        value: d,
        placeholder: "코드, 명칭 검색",
        onChange: (g) => {
          _(g.target.value), m(0);
        }
      }
    ), /* @__PURE__ */ e.createElement("div", { className: S.tbl }, /* @__PURE__ */ e.createElement("table", null, /* @__PURE__ */ e.createElement("thead", null, /* @__PURE__ */ e.createElement("tr", null, o && /* @__PURE__ */ e.createElement("th", { className: S.chk }, /* @__PURE__ */ e.createElement(
      "input",
      {
        type: "checkbox",
        checked: D,
        onChange: bn,
        "aria-label": "표시된 행 전체 선택"
      }
    )), R.map((g) => /* @__PURE__ */ e.createElement("th", { key: g.key, style: g.width ? { width: g.width } : void 0 }, g.label)))), /* @__PURE__ */ e.createElement("tbody", null, h.length === 0 ? /* @__PURE__ */ e.createElement("tr", null, /* @__PURE__ */ e.createElement("td", { className: S.emptyCell, colSpan: R.length + (o ? 1 : 0) }, N ? "조회 중…" : k || u.emptyText || "검색 결과가 없습니다")) : h.map((g, X) => /* @__PURE__ */ e.createElement(
      "tr",
      {
        key: g.cd,
        className: [
          S.row,
          X === I ? S.rowCursor : "",
          L.has(g.cd) ? S.rowPicked : ""
        ].filter(Boolean).join(" "),
        onClick: () => {
          C(X), o ? A(g) : z(g);
        }
      },
      o && /* @__PURE__ */ e.createElement("td", { className: S.chk }, /* @__PURE__ */ e.createElement(
        "input",
        {
          type: "checkbox",
          checked: L.has(g.cd),
          onChange: () => A(g),
          onClick: (M) => M.stopPropagation(),
          "aria-label": `${g.cd} 선택`
        }
      )),
      R.map((M) => {
        var ge;
        return /* @__PURE__ */ e.createElement("td", { key: M.key, className: M.align === "left" ? S.tdLeft : S.tdCenter }, M.render ? M.render(g) : String((ge = g[M.key]) != null ? ge : ""));
      })
    ))))), (w || f > 0) && /* @__PURE__ */ e.createElement("div", { className: S.more }, /* @__PURE__ */ e.createElement("span", null, w ? "표시 상한까지만 보여 주고 있습니다 — 검색어를 좁히거나 다음 쪽으로 넘기세요" : "마지막 쪽입니다"), /* @__PURE__ */ e.createElement("span", { className: S.pager }, /* @__PURE__ */ e.createElement("button", { type: "button", disabled: f === 0, onClick: () => m((g) => Math.max(0, g - 1)) }, "이전"), /* @__PURE__ */ e.createElement("b", null, f + 1), w && /* @__PURE__ */ e.createElement("button", { type: "button", onClick: () => m((g) => g + 1) }, "다음"))), o && /* @__PURE__ */ e.createElement("p", { className: S.note }, "선택 ", /* @__PURE__ */ e.createElement("b", null, L.size), "건 — 선택이 없으면 ", /* @__PURE__ */ e.createElement("b", null, "전체"), "로 조회됩니다")),
    /* @__PURE__ */ e.createElement("div", { className: S.foot }, o && /* @__PURE__ */ e.createElement("button", { type: "button", className: S.ghost, onClick: () => j(/* @__PURE__ */ new Map()) }, "초기화"), /* @__PURE__ */ e.createElement("button", { type: "button", className: S.ghost, onClick: c }, "취소"), o && /* @__PURE__ */ e.createElement("button", { type: "button", className: S.primary, onClick: H }, "확인"))
  )));
}
const mm = "_input_13uqz_1", dm = "_range_13uqz_14", _m = "_tilde_13uqz_15", pm = "_rangeErr_13uqz_16", ot = {
  input: mm,
  range: dm,
  tilde: _m,
  rangeErr: pm
};
function Tt({
  value: t,
  onChange: n,
  mode: a = "date",
  min: o,
  max: r,
  disabled: l,
  "aria-label": s,
  className: c = ""
}) {
  return /* @__PURE__ */ e.createElement(
    "input",
    {
      type: a,
      className: [ot.input, c].filter(Boolean).join(" "),
      value: t,
      min: o,
      max: r,
      disabled: l,
      "aria-label": s,
      onChange: (i) => n(i.target.value)
    }
  );
}
const Ce = (t) => String(t).padStart(2, "0");
function Ip() {
  const t = /* @__PURE__ */ new Date();
  return `${t.getFullYear()}-${Ce(t.getMonth() + 1)}-${Ce(t.getDate())}`;
}
function Rp(t) {
  if (!t) return "";
  const n = new Date(t);
  return Number.isNaN(n.getTime()) ? String(t) : `${n.getFullYear()}-${Ce(n.getMonth() + 1)}-${Ce(n.getDate())} ${Ce(n.getHours())}:${Ce(n.getMinutes())}:${Ce(n.getSeconds())}`;
}
function Tp(t, n) {
  return !!t && !!n && t <= n;
}
function qp({
  from: t,
  to: n,
  onChange: a,
  mode: o = "date",
  min: r,
  max: l,
  disabled: s,
  label: c = "기간"
}) {
  const i = !!t && !!n && t > n;
  return /* @__PURE__ */ e.createElement("span", { className: ot.range }, /* @__PURE__ */ e.createElement(
    Tt,
    {
      value: t,
      mode: o,
      min: r,
      max: l,
      disabled: s,
      "aria-label": `${c} 시작`,
      onChange: (u) => a(u, n)
    }
  ), /* @__PURE__ */ e.createElement("span", { className: ot.tilde, "aria-hidden": "true" }, "~"), /* @__PURE__ */ e.createElement(
    Tt,
    {
      value: n,
      mode: o,
      min: r,
      max: l,
      disabled: s,
      "aria-label": `${c} 끝`,
      onChange: (u) => a(t, u)
    }
  ), i && /* @__PURE__ */ e.createElement("span", { className: ot.rangeErr, role: "alert" }, "시작이 끝보다 늦습니다"));
}
function fm(t) {
  return t.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
function bm(t) {
  return t.replace(/[０-９]/g, (n) => String.fromCharCode(n.charCodeAt(0) - 65248)).replace(/[－ー−]/g, "-").replace(/，/g, ",").replace(/．/g, ".");
}
function on(t, n = !0) {
  t = bm(t);
  const a = n && /^\s*-/.test(t), o = t.split(".", 1)[0].replace(/[^\d]/g, "");
  return o ? (a ? "-" : "") + o.replace(/^0+(?=\d)/, "") : a ? "-" : "";
}
function hm(t) {
  var o;
  if (t == null || t === "") return "";
  const n = typeof t == "number" ? String(t) : t.trim(), a = /^(-?)(\d+)(\.\d+)?$/.exec(n);
  return a ? a[1] + fm(a[2]) + ((o = a[3]) != null ? o : "") : n;
}
function Em(t) {
  const n = on(t);
  if (n === "" || n === "-") return;
  const a = Number(n);
  return Number.isFinite(a) ? a : void 0;
}
function ym(t) {
  const n = t.match(/\d/g);
  return n ? n.length : 0;
}
function zp({
  value: t,
  onChangeAm: n,
  allowNegative: a = !0,
  className: o,
  ...r
}) {
  const l = F(null), s = F(null);
  return Ut(() => {
    const c = l.current, i = s.current;
    if (s.current = null, !c || i === null) return;
    let u = 0, d = 0;
    for (; u < c.value.length && d < i; )
      /\d/.test(c.value[u]) && (d += 1), u += 1;
    c.setSelectionRange(u, u);
  }), /* @__PURE__ */ e.createElement(
    "input",
    {
      ...r,
      ref: l,
      type: "text",
      inputMode: "numeric",
      className: o,
      value: hm(t),
      onChange: (c) => {
        var d;
        const i = c.target;
        s.current = ym(i.value.slice(0, (d = i.selectionStart) != null ? d : i.value.length));
        const u = on(i.value, a);
        n({ text: u, num: Em(u) });
      }
    }
  );
}
const gm = "_box_damu4_3", vm = "_banner_damu4_9", km = "_verify_damu4_10", Nm = "_t_info_damu4_15", wm = "_t_warn_damu4_16", $m = "_t_danger_damu4_17", xm = "_error_damu4_22", Cm = "_note_damu4_30", Bm = "_noteI_damu4_42", Sm = "_noteBody_damu4_43", Lm = "_badge_damu4_49", Am = "_b_muted_damu4_53", jm = "_b_ok_damu4_54", Fm = "_b_warn_damu4_55", Mm = "_b_off_damu4_56", te = {
  box: gm,
  banner: vm,
  verify: km,
  t_info: Nm,
  t_warn: wm,
  t_danger: $m,
  error: xm,
  note: Cm,
  noteI: Bm,
  noteBody: Sm,
  badge: Lm,
  b_muted: Am,
  b_ok: jm,
  b_warn: Fm,
  b_off: Mm
};
function Pp({ tone: t = "warn", className: n = "", children: a }) {
  return /* @__PURE__ */ e.createElement("div", { className: [te.box, te.banner, te[`t_${t}`], n].filter(Boolean).join(" ") }, a);
}
function Xp({ tone: t = "ok", className: n = "", children: a }) {
  const o = t === "ok" ? "info" : t === "bad" ? "danger" : "warn";
  return /* @__PURE__ */ e.createElement("div", { className: [te.box, te.verify, te[`t_${o}`], n].filter(Boolean).join(" ") }, a);
}
function Dm({ className: t = "", children: n }) {
  return n == null || n === !1 || n === "" ? null : /* @__PURE__ */ e.createElement("p", { className: [te.error, t].filter(Boolean).join(" "), role: "alert" }, typeof n == "string" ? /* @__PURE__ */ e.createElement(Im, { text: n }) : n);
}
function Op({ label: t = "안내", className: n = "", children: a }) {
  return /* @__PURE__ */ e.createElement("details", { className: [te.note, n].filter(Boolean).join(" ") }, /* @__PURE__ */ e.createElement("summary", null, /* @__PURE__ */ e.createElement("span", { className: te.noteI, "aria-hidden": "true" }, "ⓘ"), t), /* @__PURE__ */ e.createElement("div", { className: te.noteBody }, a));
}
function Wp({ tone: t = "muted", className: n = "", children: a }) {
  return /* @__PURE__ */ e.createElement("span", { className: ["axe-badge", te.badge, te[`b_${t}`], n].filter(Boolean).join(" ") }, a);
}
function Im({ text: t }) {
  return t ? /* @__PURE__ */ e.createElement(e.Fragment, null, t.split(/\*\*(.+?)\*\*/g).map((n, a) => a % 2 ? /* @__PURE__ */ e.createElement("b", { key: a }, n) : /* @__PURE__ */ e.createElement(Ht, { key: a }, n))) : null;
}
const Rm = "저장하지 않은 변경이 있습니다. 버리고 이동할까요?";
function Tm(t, n = Rm) {
  const a = F(t);
  return a.current = t, K(() => {
    if (!t) return;
    const o = (r) => {
      r.preventDefault(), r.returnValue = "";
    };
    return window.addEventListener("beforeunload", o), () => window.removeEventListener("beforeunload", o);
  }, [t]), G(() => !a.current || window.confirm(n), [n]);
}
const qm = "_overlay_111ox_2", zm = "_modal_111ox_7", Pm = "_wide_111ox_13", Xm = "_head_111ox_14", Om = "_title_111ox_18", Wm = "_close_111ox_19", Gm = "_body_111ox_23", Km = "_flush_111ox_24", Hm = "_error_111ox_25", Um = "_foot_111ox_27", ie = {
  overlay: qm,
  modal: zm,
  wide: Pm,
  head: Xm,
  title: Om,
  close: Wm,
  body: Gm,
  flush: Km,
  error: Hm,
  foot: Um
}, Be = [];
function qt(t) {
  const n = Be[Be.length - 1];
  t.key !== "Escape" || !n || !n.esc || (t.preventDefault(), n.close());
}
function Ym({
  title: t,
  onClose: n,
  children: a,
  wide: o,
  footer: r,
  headerExtra: l,
  flush: s,
  closeOnBackdrop: c = !0,
  closeOnEsc: i = !1,
  error: u,
  confirmDiscard: d = !0
}) {
  const [_, p] = y(!1), b = d ? () => {
    _ || p(!0);
  } : void 0, f = Tm(d && _, "입력한 내용을 저장하지 않고 닫을까요?"), m = () => {
    f() && n();
  }, h = F(m);
  h.current = m;
  const v = F({ close: () => h.current(), esc: i });
  return v.current.esc = i, K(() => {
    const w = v.current;
    return Be.push(w), Be.length === 1 && window.addEventListener("keydown", qt), () => {
      const E = Be.lastIndexOf(w);
      E >= 0 && Be.splice(E, 1), Be.length === 0 && window.removeEventListener("keydown", qt);
    };
  }, []), /* @__PURE__ */ e.createElement("div", { className: ie.overlay, onClick: c ? m : void 0 }, /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [ie.modal, o ? ie.wide : ""].filter(Boolean).join(" "),
      role: "dialog",
      "aria-modal": "true",
      "aria-label": t,
      onClick: (w) => w.stopPropagation()
    },
    /* @__PURE__ */ e.createElement("header", { className: ie.head }, /* @__PURE__ */ e.createElement("strong", { className: ie.title }, t), l, /* @__PURE__ */ e.createElement("button", { type: "button", className: ie.close, onClick: m, "aria-label": "닫기" }, "✕")),
    /* @__PURE__ */ e.createElement(
      "div",
      {
        className: [ie.body, s ? ie.flush : ""].filter(Boolean).join(" "),
        onInputCapture: b,
        onChangeCapture: b
      },
      a
    ),
    u != null && u !== !1 && u !== "" && /* @__PURE__ */ e.createElement("div", { className: ie.error }, /* @__PURE__ */ e.createElement(Dm, null, u)),
    r && /* @__PURE__ */ e.createElement("footer", { className: ie.foot }, r)
  ));
}
function Gp(t = 4e3) {
  const [n, a] = y(""), [o, r] = y(!1), l = F(void 0), s = G((u) => {
    window.clearTimeout(l.current), r(!1), a(u), l.current = window.setTimeout(() => a(""), t);
  }, [t]), c = G((u) => {
    window.clearTimeout(l.current), r(!0), a(u);
  }, []), i = G(() => {
    window.clearTimeout(l.current), r(!1), a("");
  }, []);
  return [n, s, c, o, i];
}
const Vm = "_message_psco6_1", Jm = "_details_psco6_2", Zm = "_warn_psco6_7", Qm = "_field_psco6_8", nt = {
  message: Vm,
  details: Jm,
  warn: Zm,
  field: Qm
};
function Kp() {
  var b, f;
  const [t, n] = y(null), [a, o] = y(""), r = F(null), l = F(null), s = F(null), c = G((m) => new Promise((h) => {
    n({ kind: "confirm", opts: m, resolve: h });
  }), []), i = G((m) => new Promise((h) => {
    var v, w, E, N;
    o((N = (E = m.defaultValue) != null ? E : (w = (v = m.choices) == null ? void 0 : v[0]) == null ? void 0 : w.value) != null ? N : ""), n({ kind: "prompt", opts: m, resolve: h });
  }), []);
  K(() => {
    var m, h, v;
    t && (t.kind === "prompt" ? (m = s.current) == null || m.focus() : t.opts.danger ? (h = l.current) == null || h.focus() : (v = r.current) == null || v.focus());
  }, [t]);
  const u = (m) => {
    t && (t.kind === "confirm" ? t.resolve(m) : t.resolve(m ? a : null), n(null));
  }, d = t == null ? void 0 : t.opts, _ = (t == null ? void 0 : t.kind) === "prompt" && !!t.opts.required && !a.trim(), p = t && d ? /* @__PURE__ */ e.createElement(
    Ym,
    {
      title: d.title,
      onClose: () => u(!1),
      closeOnBackdrop: !1,
      closeOnEsc: !0,
      confirmDiscard: !1,
      footer: /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(_t, { ref: l, onClick: () => u(!1) }, (b = d.cancelLabel) != null ? b : "취소"), /* @__PURE__ */ e.createElement(
        _t,
        {
          ref: r,
          variant: d.danger ? "danger" : "primary",
          disabled: _,
          onClick: () => u(!0)
        },
        (f = d.confirmLabel) != null ? f : "확인"
      ))
    },
    d.message && /* @__PURE__ */ e.createElement("div", { className: nt.message }, d.message),
    d.details && d.details.length > 0 && /* @__PURE__ */ e.createElement("ul", { className: nt.details }, d.details.map((m, h) => /* @__PURE__ */ e.createElement("li", { key: h }, m))),
    d.irreversible && /* @__PURE__ */ e.createElement("p", { className: nt.warn }, "이 작업은 되돌릴 수 없습니다."),
    t.kind === "prompt" && /* @__PURE__ */ e.createElement("label", { className: nt.field }, /* @__PURE__ */ e.createElement("span", null, t.opts.label), t.opts.choices ? /* @__PURE__ */ e.createElement("select", { ref: s, value: a, onChange: (m) => o(m.target.value) }, t.opts.choices.map((m) => /* @__PURE__ */ e.createElement("option", { key: m.value, value: m.value }, m.label))) : /* @__PURE__ */ e.createElement(
      "input",
      {
        ref: s,
        value: a,
        placeholder: t.opts.placeholder,
        maxLength: t.opts.maxLength,
        onChange: (m) => o(m.target.value),
        onKeyDown: (m) => {
          m.key === "Enter" && !_ && (m.preventDefault(), u(!0));
        }
      }
    ))
  ) : null;
  return { confirm: c, prompt: i, dialog: p };
}
function Hp(t, n) {
  const a = n ? `${n}에 실패했습니다 — ` : "", o = t > 0 ? ` (오류 ${t})` : "";
  return a + ed(t) + o;
}
function ed(t) {
  return t === 0 ? "서버에 연결하지 못했습니다. 네트워크 상태를 확인한 뒤 다시 시도하세요" : t === 400 || t === 422 ? "서버가 요청 내용을 받아들이지 않았습니다. 입력값을 확인한 뒤 다시 시도하세요" : t === 401 ? "로그인이 필요합니다. 다시 로그인해 주세요" : t === 403 ? "이 작업을 할 권한이 없습니다. 필요하면 관리자에게 권한을 요청하세요" : t === 404 ? "요청한 자료나 기능을 찾지 못했습니다. 화면을 새로고침한 뒤 다시 시도하고, 계속되면 관리자에게 알려 주세요" : t === 409 ? "다른 곳에서 먼저 바뀌었습니다. 다시 조회한 뒤 시도하세요" : t === 413 ? "보낸 자료가 너무 큽니다. 크기를 줄여 다시 시도하세요" : t === 429 ? "요청이 너무 많습니다. 잠시 후 다시 시도하세요" : t >= 500 ? "서버에서 처리하지 못했습니다. 잠시 후 다시 시도하고, 계속되면 관리자에게 알려 주세요" : "요청을 처리하지 못했습니다. 다시 시도하세요";
}
const td = "_section_xivae_3", nd = "_row_xivae_10", ad = "_label_xivae_15", od = "_value_xivae_20", rd = "_invalid_xivae_34", ld = "_help_xivae_36", sd = "_err_xivae_36", cd = "_req_xivae_40", id = "_opt_xivae_41", ud = "_sr_xivae_42", md = "_ro_xivae_10", dd = "_readonly_xivae_49", _d = "_hint_xivae_56", pd = "_toggle_xivae_64", Y = {
  section: td,
  row: nd,
  label: ad,
  value: od,
  invalid: rd,
  help: ld,
  err: sd,
  req: cd,
  opt: id,
  sr: ud,
  ro: md,
  readonly: dd,
  hint: _d,
  toggle: pd
};
let fd = 0;
const bd = /* @__PURE__ */ new Set(["input", "select", "textarea"]);
function Up({
  label: t,
  children: n,
  hint: a,
  ro: o,
  htmlFor: r,
  required: l,
  optional: s,
  help: c,
  error: i,
  className: u = ""
}) {
  var w, E, N, $;
  const d = F(`axe-fr${++fd}`).current, _ = c ? `${d}-help` : void 0, p = i ? `${d}-err` : void 0, b = [_, p].filter(Boolean).join(" ") || void 0, f = a && a.replace(/\*\*(.+?)\*\*/g, "$1");
  let m = n;
  const h = wt.count(n) === 1 ? wt.toArray(n)[0] : null;
  if (yn(h) && typeof h.type == "string" && bd.has(h.type)) {
    const k = h, x = k.props;
    m = gn(k, {
      id: (w = x.id) != null ? w : r,
      "aria-describedby": (E = x["aria-describedby"]) != null ? E : b,
      "aria-invalid": (N = x["aria-invalid"]) != null ? N : i ? !0 : void 0,
      "aria-required": ($ = x["aria-required"]) != null ? $ : l ? !0 : void 0
    });
  }
  const v = /* @__PURE__ */ e.createElement(e.Fragment, null, t, l && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("span", { className: Y.req, "aria-hidden": "true" }, "*"), /* @__PURE__ */ e.createElement("span", { className: Y.sr }, "필수")), s && /* @__PURE__ */ e.createElement("span", { className: Y.opt }, "(선택)"));
  return /* @__PURE__ */ e.createElement("div", { className: ["axe-form-row", Y.row, o ? Y.ro : "", i ? Y.invalid : "", u].filter(Boolean).join(" ") }, /* @__PURE__ */ e.createElement("span", { className: `axe-form-label ${Y.label}` }, r ? /* @__PURE__ */ e.createElement("label", { htmlFor: r }, v) : v, a && /* @__PURE__ */ e.createElement("span", { className: `axe-form-hint ${Y.hint}`, title: f, role: "img", "aria-label": `도움말: ${f}`, tabIndex: 0 }, "?")), /* @__PURE__ */ e.createElement("span", { className: `axe-form-value ${Y.value}` }, m, c && /* @__PURE__ */ e.createElement("span", { id: _, className: Y.help }, c), i && /* @__PURE__ */ e.createElement("span", { id: p, className: Y.err }, i)));
}
function Yp({ title: t, children: n, className: a = "" }) {
  return /* @__PURE__ */ e.createElement("section", { className: ["axe-form-section", Y.section, a].filter(Boolean).join(" ") }, /* @__PURE__ */ e.createElement("h3", null, t), n);
}
function Vp({ children: t }) {
  return /* @__PURE__ */ e.createElement("span", { className: Y.readonly }, t);
}
function Jp({ checked: t, onChange: n, disabled: a, label: o, className: r = "" }) {
  return /* @__PURE__ */ e.createElement("label", { className: [Y.toggle, r].filter(Boolean).join(" ") }, /* @__PURE__ */ e.createElement("input", { type: "checkbox", checked: t, disabled: a, onChange: (l) => n(l.target.checked) }), /* @__PURE__ */ e.createElement("span", null, o));
}
const hd = "_panel_1w7xx_2", Ed = "_band_1w7xx_7", yd = "_chev_1w7xx_11", gd = "_title_1w7xx_17", vd = "_note_1w7xx_19", kd = "_chip_1w7xx_21", Nd = "_other_1w7xx_32", wd = "_reset_1w7xx_33", $d = "_form_1w7xx_42", be = {
  panel: hd,
  band: Ed,
  chev: yd,
  title: gd,
  note: vd,
  chip: kd,
  other: Nd,
  reset: wd,
  form: $d
};
function Zp({
  chips: t,
  onReset: n,
  open: a,
  onToggle: o,
  toggleLabel: r = "상세검색",
  title: l = "적용된 조건",
  note: s,
  children: c,
  hideWhenEmpty: i,
  ariaLabel: u = "상세검색",
  className: d = ""
}) {
  const _ = F(null);
  if (i && !a && t.length === 0) return null;
  const p = (f, m = 0) => {
    var N, $, k;
    const h = (N = document.querySelector(`section[aria-label="${CSS.escape(u)}"]`)) != null ? N : _.current, v = h == null ? void 0 : h.querySelectorAll("button[data-chip-clear]"), w = (k = v && (($ = v[f]) != null ? $ : v[f - 1])) != null ? k : h == null ? void 0 : h.querySelector("button[aria-expanded]"), E = !document.activeElement || document.activeElement === document.body;
    w && w !== document.activeElement && (m === 0 || E) && w.focus(), m < 4 && setTimeout(() => p(f, m + 1), 250);
  }, b = (f) => {
    t[f].onClear(), requestAnimationFrame(() => p(f));
  };
  return /* @__PURE__ */ e.createElement("section", { className: [be.panel, d].filter(Boolean).join(" "), "aria-label": u }, /* @__PURE__ */ e.createElement("div", { className: be.band, ref: _ }, o && /* @__PURE__ */ e.createElement("button", { type: "button", className: be.chev, "aria-expanded": !!a, onClick: o }, /* @__PURE__ */ e.createElement("span", { "aria-hidden": "true" }, a ? "⌃" : "⌄"), " ", r), l !== null && /* @__PURE__ */ e.createElement("span", { className: be.title, "aria-live": "polite" }, l, " ", /* @__PURE__ */ e.createElement("b", null, t.length), "개"), t.map((f, m) => {
    var h;
    return /* @__PURE__ */ e.createElement("span", { key: f.key, className: [be.chip, f.tone === "other" ? be.other : ""].filter(Boolean).join(" ") }, f.text, /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        "data-chip-clear": !0,
        "aria-label": `${(h = f.label) != null ? h : typeof f.text == "string" ? f.text : "조건"} 해제`,
        onClick: () => b(m)
      },
      "✕"
    ));
  }), n && t.length > 0 && /* @__PURE__ */ e.createElement("button", { type: "button", className: be.reset, onClick: () => {
    n(), requestAnimationFrame(() => p(0));
  } }, "초기화"), s && /* @__PURE__ */ e.createElement("span", { className: be.note }, s)), a && c && /* @__PURE__ */ e.createElement("div", { className: be.form }, c));
}
const xd = "_zone_1y6sp_2", Cd = "_drag_1y6sp_8", Bd = "_busy_1y6sp_9", Sd = "_attached_1y6sp_10", Ld = "_left_1y6sp_12", Ad = "_icon_1y6sp_13", jd = "_title_1y6sp_18", Fd = "_desc_1y6sp_19", Md = "_right_1y6sp_20", Dd = "_count_1y6sp_21", Id = "_pick_1y6sp_22", ae = {
  zone: xd,
  drag: Cd,
  busy: Bd,
  attached: Sd,
  left: Ld,
  icon: Ad,
  title: jd,
  desc: Fd,
  right: Md,
  count: Dd,
  pick: Id
};
function Qp({
  onFiles: t,
  title: n = "파일 업로드",
  desc: a,
  countText: o,
  accept: r,
  multiple: l = !0,
  disabled: s,
  attached: c,
  pickLabel: i = "파일 선택",
  className: u = ""
}) {
  const d = F(null), [_, p] = y(!1), b = (f) => {
    !f || f.length === 0 || s || t(Array.from(f));
  };
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [ae.zone, _ ? ae.drag : "", s ? ae.busy : "", c ? ae.attached : "", u].filter(Boolean).join(" "),
      onClick: () => {
        var f;
        s || (f = d.current) == null || f.click();
      },
      onDragOver: (f) => {
        f.preventDefault(), s || p(!0);
      },
      onDragLeave: () => p(!1),
      onDrop: (f) => {
        f.preventDefault(), p(!1), b(f.dataTransfer.files);
      }
    },
    /* @__PURE__ */ e.createElement("div", { className: ae.left }, /* @__PURE__ */ e.createElement("div", { className: ae.icon, "aria-hidden": "true" }, /* @__PURE__ */ e.createElement("svg", { width: "22", height: "22", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }, /* @__PURE__ */ e.createElement("polyline", { points: "16 16 12 12 8 16" }), /* @__PURE__ */ e.createElement("line", { x1: "12", y1: "12", x2: "12", y2: "21" }), /* @__PURE__ */ e.createElement("path", { d: "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" }))), /* @__PURE__ */ e.createElement("div", null, /* @__PURE__ */ e.createElement("div", { className: ae.title }, n), a && /* @__PURE__ */ e.createElement("div", { className: ae.desc }, a))),
    /* @__PURE__ */ e.createElement("div", { className: ae.right }, o && /* @__PURE__ */ e.createElement("span", { className: ae.count, "aria-live": "polite" }, o), /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: ae.pick,
        disabled: s,
        onClick: (f) => {
          var m;
          f.stopPropagation(), (m = d.current) == null || m.click();
        }
      },
      i
    ), /* @__PURE__ */ e.createElement(
      "input",
      {
        ref: d,
        type: "file",
        accept: r,
        multiple: l,
        hidden: !0,
        onChange: (f) => {
          b(f.target.files), f.target.value = "";
        }
      }
    ))
  );
}
function Rd(t, n) {
  var l, s;
  const a = (l = t.headers.get("Content-Disposition")) != null ? l : "", o = /filename\*=UTF-8''([^;]+)/i.exec(a);
  if (o)
    try {
      return decodeURIComponent(o[1]);
    } catch {
    }
  const r = /filename="?([^";]+)"?/i.exec(a);
  return (s = r == null ? void 0 : r[1]) != null ? s : n;
}
function rn(t, n) {
  const a = URL.createObjectURL(t), o = document.createElement("a");
  o.href = a, o.download = n, document.body.appendChild(o), o.click(), o.remove(), setTimeout(() => URL.revokeObjectURL(a), 1e3);
}
async function ef(t, n, a) {
  rn(await t.blob(), a != null ? a : Rd(t, n));
}
function Td(t) {
  const n = [];
  return t.querySelectorAll("table").forEach((a) => {
    const o = [];
    Array.from(a.rows).forEach((r) => {
      if (r.hasAttribute("data-state") || r.getAttribute("aria-hidden") === "true") return;
      const l = [];
      let s = 0;
      const c = () => {
        for (; o[s] && o[s].n > 0; )
          o[s].n -= 1, o[s].skip || l.push(""), s += 1;
      };
      Array.from(r.cells).forEach((i) => {
        c();
        const u = zd(i), d = u ? "" : Pd(i), _ = Math.max(1, i.colSpan || 1), p = Math.max(1, i.rowSpan || 1);
        for (let b = 0; b < _; b += 1)
          u || l.push(b === 0 ? d : ""), o[s] = { n: p - 1, skip: u }, s += 1;
      }), c(), l.some((i) => i !== "") && n.push(l.map(Xd).join(","));
    });
  }), n.join(`\r
`);
}
function qd(t, n) {
  const a = n.toLowerCase().endsWith(".csv") ? n : `${n}.csv`;
  rn(new Blob(["\uFEFF", t], { type: "text/csv;charset=utf-8" }), a);
}
function zd(t) {
  var n;
  return ((n = t.textContent) != null ? n : "").trim() !== "" ? !1 : !!t.querySelector("input[type=checkbox], input[type=radio]");
}
function Pd(t) {
  var o, r, l;
  let n = ((r = (o = t.innerText) != null ? o : t.textContent) != null ? r : "").replace(/\s+/g, " ").trim();
  if (!n) {
    const s = t.querySelector("input:not([type=checkbox]):not([type=radio]), select, textarea");
    s && (n = s.value.trim());
  }
  if (n === "—" || n === "-" || n === "–") return "";
  const a = /^([△▲-]?)\s*¥?\s*(\d{1,3}(?:,\d{3})+|\d+)(\.\d+)?$/.exec(n);
  return a ? (a[1] ? "-" : "") + a[2].replace(/,/g, "") + ((l = a[3]) != null ? l : "") : n;
}
function Xd(t) {
  return /[",\r\n]/.test(t) ? `"${t.replace(/"/g, '""')}"` : t;
}
function tf({ target: t, fileName: n, label: a = "CSV", disabled: o }) {
  return /* @__PURE__ */ e.createElement(
    _t,
    {
      disabled: o,
      title: "화면에 보이는 표를 그대로 CSV 로 내려받습니다",
      onClick: () => {
        const r = t.current;
        r && qd(Td(r), typeof n == "function" ? n() : n);
      }
    },
    a
  );
}
const zt = 30, Od = BigInt(10);
function Re(t) {
  let n = BigInt(1);
  for (let a = 0; a < t; a += 1) n = n * Od;
  return n;
}
function Ee(t, n = 0) {
  return { u: t, s: n };
}
const ln = Ee(BigInt(0));
function sn(t, n) {
  if (t.s === n.s) return [t.u, n.u, t.s];
  const a = Math.max(t.s, n.s);
  return [t.u * Re(a - t.s), n.u * Re(a - n.s), a];
}
function Ve(t, n) {
  const [a, o, r] = sn(t, n);
  return Ee(a + o, r);
}
function yt(t, n) {
  const [a, o, r] = sn(t, n);
  return Ee(a - o, r);
}
function ue(t, n) {
  return Ee(t.u * n.u, t.s + n.s);
}
function Se(t, n) {
  if (n.u === BigInt(0)) return null;
  const a = t.u * Re(n.s + zt), o = n.u * Re(t.s);
  return Ee(a / o, zt);
}
function cn(t) {
  return Ee(-t.u, t.s);
}
function ye(t, n, a) {
  if (n >= t.s)
    return Ee(t.u * Re(n - t.s), n);
  const o = Re(t.s - n), r = t.u < BigInt(0), l = r ? -t.u : t.u, s = l / o, c = l % o;
  let i;
  return c === BigInt(0) || a === "down" ? i = s : a === "up" ? i = s + BigInt(1) : i = c * BigInt(2) >= o ? s + BigInt(1) : s, Ee(r ? -i : i, n);
}
function P(t) {
  const n = t.trim().replace(/,/g, "");
  if (!/^[+-]?(\d+(\.\d*)?|\.\d+)$/.test(n)) return null;
  const a = n.startsWith("-"), o = n.replace(/^[+-]/, ""), r = o.indexOf("."), l = r < 0 ? o : o.slice(0, r) + o.slice(r + 1), s = r < 0 ? 0 : o.length - r - 1, c = BigInt(l === "" ? "0" : l);
  return Ee(a ? -c : c, s);
}
function gt(t) {
  var a;
  const n = P(String(t));
  return n || ((a = P(t.toFixed(20))) != null ? a : ln);
}
function re(t, n = t.s, a = !1) {
  const o = ye(t, Math.max(n, 0), "half"), r = o.u < BigInt(0), l = (r ? -o.u : o.u).toString().padStart(n + 1, "0"), s = l.length - n;
  let c = l.slice(0, s);
  const i = l.slice(s);
  return a && (c = c.replace(/\B(?=(\d{3})+(?!\d))/g, ",")), (r ? "-" : "") + c + (n > 0 ? "." + i : "");
}
function pt(t) {
  const n = /^(\d{4})-(\d{2})-(\d{2})$/.exec(t.trim());
  if (!n) return null;
  const a = Number(n[1]), o = Number(n[2]), r = Number(n[3]);
  return o < 1 || o > 12 || r < 1 || r > vt(a, o) ? null : { y: a, m: o, d: r };
}
function Wd(t) {
  return t % 4 === 0 && t % 100 !== 0 || t % 400 === 0;
}
function vt(t, n) {
  return n === 2 ? Wd(t) ? 29 : 28 : [4, 6, 9, 11].includes(n) ? 30 : 31;
}
function Ie({ y: t, m: n, d: a }) {
  const o = Math.floor((14 - n) / 12), r = t + 4800 - o, l = n + 12 * o - 3;
  return a + Math.floor((153 * l + 2) / 5) + 365 * r + Math.floor(r / 4) - Math.floor(r / 100) + Math.floor(r / 400) - 32045;
}
function un(t, n) {
  const a = Ie(t) + n + 32044, o = Math.floor((4 * a + 3) / 146097), r = a - Math.floor(146097 * o / 4), l = Math.floor((4 * r + 3) / 1461), s = r - Math.floor(1461 * l / 4), c = Math.floor((5 * s + 2) / 153);
  return {
    d: s - Math.floor((153 * c + 2) / 5) + 1,
    m: c + 3 - 12 * Math.floor(c / 10),
    y: 100 * o + l - 4800 + Math.floor(c / 10)
  };
}
function mn(t, n, a = "exclude-first") {
  const o = Ie(t) > Ie(n), r = o ? n : t, l = o ? t : n, s = a === "include-first", c = Ie(l) - Ie(r) + (s ? 1 : 0), i = s ? un(l, 1) : l;
  let u = i.y - r.y, d = i.m - r.m, _ = i.d - r.d;
  if (_ < 0) {
    d -= 1;
    const p = i.m === 1 ? 12 : i.m - 1, b = i.m === 1 ? i.y - 1 : i.y;
    _ += vt(b, p);
  }
  return d < 0 && (u -= 1, d += 12), { days: c, y: u, m: d, d: _, swapped: o };
}
function rt(t, n) {
  return un(t, n);
}
function Pt(t, n) {
  const a = t.y * 12 + (t.m - 1) + n, o = Math.floor(a / 12), r = a % 12 + 1;
  return { y: o, m: r, d: Math.min(t.d, vt(o, r)) };
}
const Gd = ["월", "화", "수", "목", "금", "토", "일"];
function ft(t) {
  return Gd[Ie(t) % 7];
}
function ee(t) {
  return `${t.y}-${String(t.m).padStart(2, "0")}-${String(t.d).padStart(2, "0")}`;
}
const Ge = [
  { code: "KRW", label: "원", per: 1, krw: "1" },
  { code: "JPY", label: "엔", per: 100, krw: "941.20" },
  { code: "USD", label: "달러", per: 1, krw: "1386.50" },
  { code: "EUR", label: "유로", per: 1, krw: "1501.30" },
  { code: "CNY", label: "위안", per: 1, krw: "190.40" },
  { code: "GBP", label: "파운드", per: 1, krw: "1752.80" }
], it = {
  원: "KRW",
  엔: "JPY",
  달러: "USD",
  불: "USD",
  유로: "EUR",
  위안: "CNY",
  파운드: "GBP"
};
function Xt(t) {
  var n;
  return (n = it[t]) != null ? n : t in it ? it[t] : null;
}
function bt(t, n) {
  return t.find((a) => a.code === n);
}
function dn(t) {
  return t.code === "KRW" ? "KRW 기준" : `${t.code} ${t.per} = ${t.krw}원`;
}
function _n(t, n, a, o) {
  const r = bt(t, a), l = bt(t, o);
  if (!r || !l) return null;
  const s = P(r.krw), c = P(l.krw), i = P(String(r.per)), u = P(String(l.per));
  if (!s || !c || !i || !u) return null;
  const d = Se(ue(n, s), i);
  if (!d) return null;
  const _ = Se(ue(d, u), c);
  return _ ? {
    value: ye(_, 2, "half"),
    notice: `${dn(r)} · 샘플 고시(원천 미결)`
  } : null;
}
function Kd(t, n) {
  let a = null;
  for (const r of t)
    if (r.value) {
      if (a === null) {
        a = r.sign === "-" ? cn(r.value) : r.value;
        continue;
      }
      switch (r.sign) {
        case "+":
          a = Ve(a, r.value);
          break;
        case "-":
          a = yt(a, r.value);
          break;
        case "*":
          a = ue(a, r.value);
          break;
        default: {
          const l = Se(a, r.value);
          if (!l) return { ok: !1, error: "divide-by-zero" };
          a = l;
          break;
        }
      }
    }
  const o = a != null ? a : ln;
  return { ok: !0, value: n ? ye(o, n.digits, n.mode) : o };
}
const Ot = [
  { key: "+", label: "+", hot: "A" },
  { key: "-", label: "−", hot: "S" },
  { key: "*", label: "×", hot: "D" },
  { key: "/", label: "÷", hot: "F" }
];
function Ue() {
  return { sign: "+", text: "" };
}
function Hd(t) {
  const n = t.replace(/[^\d.-]/g, ""), a = n.startsWith("-"), o = n.replace(/-/g, ""), r = o.indexOf("."), l = r < 0 ? o : o.slice(0, r), s = r < 0 ? "" : "." + o.slice(r + 1).replace(/\./g, "");
  return (a ? "-" : "") + l.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + s;
}
function Ud(t) {
  return t.map((n) => ({ sign: n.sign, value: P(n.text) }));
}
function Yd(t) {
  const { lines: n, onLines: a, active: o, onActive: r, digits: l, onDigits: s, mode: c, onMode: i } = t, u = F([]), d = Math.min(o, n.length - 1);
  K(() => {
    var E;
    (E = u.current[d]) == null || E.focus();
  }, [d, n.length]);
  const _ = Kd(Ud(n), { digits: l, mode: c }), p = _.ok ? re(_.value, l, !0) : "0으로 나눌 수 없음", b = (E, N) => {
    a(n.map(($, k) => k === E ? { ...$, ...N } : $));
  }, f = (E = n.length, N = "") => {
    const $ = [...n];
    $.splice(E, 0, { ...Ue(), text: N }), a($), r(E);
  }, m = (E) => {
    if (n.length === 1) {
      a([Ue()]);
      return;
    }
    a(n.filter((N, $) => $ !== E)), r(Math.max(0, E - 1));
  }, h = () => {
    _.ok && f(n.length, re(_.value, l, !0));
  }, v = (E, N) => {
    const $ = E.key, k = Vd($);
    if (k && !($ === "-" && n[N].text === "")) {
      E.preventDefault(), b(N, { sign: k });
      return;
    }
    if ($ === "v" || $ === "V") {
      E.preventDefault(), h();
      return;
    }
    $ === "Enter" ? (E.preventDefault(), N === n.length - 1 ? f() : r(N + 1)) : $ === "ArrowDown" ? (E.preventDefault(), r(Math.min(N + 1, n.length - 1))) : $ === "ArrowUp" ? (E.preventDefault(), r(Math.max(N - 1, 0))) : $ === "Insert" ? (E.preventDefault(), f(N + 1)) : $ === "Delete" && n[N].text === "" ? (E.preventDefault(), m(N)) : $ === "F4" && (E.preventDefault(), w());
  }, w = () => {
    a([Ue()]), r(0);
  };
  return /* @__PURE__ */ e.createElement("div", { className: "bical-general" }, /* @__PURE__ */ e.createElement("div", { className: "bical-side" }, /* @__PURE__ */ e.createElement("div", { className: "bical-keys" }, /* @__PURE__ */ e.createElement("button", { type: "button", className: "bical-key", onClick: () => f(d + 1) }, "라인추가 (Ins)"), /* @__PURE__ */ e.createElement("button", { type: "button", className: "bical-key", onClick: () => m(d) }, "라인삭제 (Del)"), /* @__PURE__ */ e.createElement("button", { type: "button", className: "bical-key", onClick: h }, "현재금액추가 (V)"), /* @__PURE__ */ e.createElement("button", { type: "button", className: "bical-key", onClick: w }, "초기화 (F4)")), /* @__PURE__ */ e.createElement("div", { className: "bical-sub" }, "부호"), /* @__PURE__ */ e.createElement("div", { className: "bical-keys" }, Ot.map((E) => {
    var N;
    return /* @__PURE__ */ e.createElement(
      "button",
      {
        key: E.key,
        type: "button",
        className: "bical-key",
        "aria-pressed": ((N = n[d]) == null ? void 0 : N.sign) === E.key,
        onClick: () => b(d, { sign: E.key })
      },
      E.label,
      " (",
      E.hot,
      ")"
    );
  })), /* @__PURE__ */ e.createElement("div", { className: "bical-sub" }, "결과값 자리수"), /* @__PURE__ */ e.createElement("select", { className: "bical-select", value: l, onChange: (E) => s(Number(E.target.value)) }, [0, 1, 2, 3, 4].map((E) => /* @__PURE__ */ e.createElement("option", { key: E, value: E }, E))), /* @__PURE__ */ e.createElement("div", { className: "bical-sub" }, "표기방법"), /* @__PURE__ */ e.createElement("select", { className: "bical-select", value: c, onChange: (E) => i(E.target.value) }, /* @__PURE__ */ e.createElement("option", { value: "half" }, "반올림"), /* @__PURE__ */ e.createElement("option", { value: "up" }, "올림"), /* @__PURE__ */ e.createElement("option", { value: "down" }, "버림"))), /* @__PURE__ */ e.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ e.createElement("div", { className: "bical-grid" }, n.map((E, N) => {
    var $;
    return /* @__PURE__ */ e.createElement("div", { key: N, className: `bical-line${N === d ? " bical-line--active" : ""}` }, /* @__PURE__ */ e.createElement("span", { className: "bical-caret" }, N === d ? "❯" : ""), /* @__PURE__ */ e.createElement("span", { className: "bical-sign" }, ($ = Ot.find((k) => k.key === E.sign)) == null ? void 0 : $.label), /* @__PURE__ */ e.createElement(
      "input",
      {
        ref: (k) => {
          u.current[N] = k;
        },
        value: E.text,
        inputMode: "decimal",
        "aria-label": `${N + 1}번째 금액`,
        onFocus: () => r(N),
        onChange: (k) => b(N, { text: Hd(k.target.value) }),
        onKeyDown: (k) => v(k, N)
      }
    ));
  })), /* @__PURE__ */ e.createElement("div", { className: `bical-result${_.ok ? "" : " bical-error"}` }, /* @__PURE__ */ e.createElement("div", { className: "bical-explain" }, "결과값 · 좌→우 순차 계산(연산자 우선순위 없음)"), /* @__PURE__ */ e.createElement("div", { className: "bical-value" }, p))));
}
function Vd(t) {
  const n = t.toLowerCase();
  return n === "a" || t === "+" ? "+" : n === "s" || t === "-" ? "-" : n === "d" || t === "*" ? "*" : n === "f" || t === "/" ? "/" : null;
}
function Jd(t) {
  const n = [];
  let a = 0;
  for (; a < t.length; ) {
    const o = t[a];
    if (o === " " || o === "	" || o === `
`)
      a += 1;
    else if (o >= "0" && o <= "9" || o === "." || o === ",") {
      let r = a;
      for (; r < t.length && (t[r] >= "0" && t[r] <= "9" || t[r] === "." || t[r] === ","); ) r += 1;
      const l = P(t.slice(a, r));
      if (!l) return null;
      n.push({ t: "num", v: l }), a = r;
    } else if (o === "+" || o === "-" || o === "*" || o === "/")
      n.push({ t: "op", v: o }), a += 1;
    else if (o === "(")
      n.push({ t: "(" }), a += 1;
    else if (o === ")")
      n.push({ t: ")" }), a += 1;
    else
      return null;
  }
  return n;
}
class Zd {
  constructor(n) {
    this.tokens = n, this.at = 0;
  }
  parse() {
    const n = this.expr();
    return n.ok && this.at !== this.tokens.length ? { ok: !1, error: "syntax" } : n;
  }
  peek() {
    return this.tokens[this.at];
  }
  expr() {
    let n = this.term();
    if (!n.ok) return n;
    for (; ; ) {
      const a = this.peek();
      if (!a || a.t !== "op" || a.v !== "+" && a.v !== "-") return n;
      this.at += 1;
      const o = this.term();
      if (!o.ok) return o;
      n = { ok: !0, value: a.v === "+" ? Ve(n.value, o.value) : yt(n.value, o.value) };
    }
  }
  term() {
    let n = this.unary();
    if (!n.ok) return n;
    for (; ; ) {
      const a = this.peek();
      if (!a || a.t !== "op" || a.v !== "*" && a.v !== "/") return n;
      this.at += 1;
      const o = this.unary();
      if (!o.ok) return o;
      if (a.v === "*")
        n = { ok: !0, value: ue(n.value, o.value) };
      else {
        const r = Se(n.value, o.value);
        if (!r) return { ok: !1, error: "divide-by-zero" };
        n = { ok: !0, value: r };
      }
    }
  }
  unary() {
    const n = this.peek();
    if (n && n.t === "op" && (n.v === "+" || n.v === "-")) {
      this.at += 1;
      const a = this.unary();
      return a.ok ? { ok: !0, value: n.v === "-" ? cn(a.value) : a.value } : a;
    }
    return this.primary();
  }
  primary() {
    const n = this.peek();
    if (!n) return { ok: !1, error: "syntax" };
    if (n.t === "num")
      return this.at += 1, { ok: !0, value: n.v };
    if (n.t === "(") {
      this.at += 1;
      const a = this.expr();
      if (!a.ok) return a;
      const o = this.peek();
      return !o || o.t !== ")" ? { ok: !1, error: "syntax" } : (this.at += 1, a);
    }
    return { ok: !1, error: "syntax" };
  }
}
function Qd(t) {
  const n = Jd(t);
  return !n || n.length === 0 ? { ok: !1, error: "syntax" } : new Zd(n).parse();
}
const Ye = [
  "산술식 — 1,200만 + 350만 × 2",
  "비율 — 3,000,000의 15%",
  "기간 — 2026-01-01부터 2026-03-31까지 며칠",
  "날짜 가감 — 2026-07-17부터 90일 후",
  "환율 — 150만엔을 원화로 (샘플 고시)"
], e_ = /(\d{4})\s*[.\-/년]\s*(\d{1,2})\s*[.\-/월]\s*(\d{1,2})\s*일?/g;
function t_(t, n) {
  return t.replace(/오늘/g, ee(n)).replace(/내일/g, ee(rt(n, 1))).replace(/어제/g, ee(rt(n, -1)));
}
function n_(t) {
  const n = [];
  for (const a of t.matchAll(e_)) {
    const o = pt(`${a[1]}-${a[2].padStart(2, "0")}-${a[3].padStart(2, "0")}`);
    o && n.push(o);
  }
  return n;
}
const a_ = /부터|까지|에서|일수|며칠|기간|차이|~/;
function o_(t, n) {
  if (n.length < 2 || !a_.test(t)) return null;
  const a = /초일\s*산입|양편넣기/.test(t), o = mn(n[0], n[1], a ? "include-first" : "exclude-first"), r = a ? "초일산입 말일산입" : "초일불산입 말일산입";
  return {
    ok: !0,
    explain: `${ee(n[0])} ~ ${ee(n[1])} 기간(${r})` + (o.swapped ? " · 역순 입력" : ""),
    value: `${o.days}일 (${o.y}년 ${o.m}개월 ${o.d}일)`
  };
}
const r_ = /(\d+)\s*(일|주|개월|달|년)\s*(후|뒤|이후|전|이전)/;
function l_(t, n) {
  if (n.length !== 1) return null;
  const a = r_.exec(t);
  if (!a) return null;
  const o = Number(a[1]), r = a[3] === "전" || a[3] === "이전", l = r ? -o : o, s = n[0];
  let c;
  return a[2] === "일" ? c = rt(s, l) : a[2] === "주" ? c = rt(s, l * 7) : a[2] === "년" ? c = Pt(s, l * 12) : c = Pt(s, l), {
    ok: !0,
    explain: `${ee(s)} 에서 ${o}${a[2]} ${r ? "전" : "후"}`,
    value: `${ee(c)} (${ft(c)})`
  };
}
function s_(t, n) {
  if (n.length === 0) return null;
  const a = /([\d,]+(?:\.\d+)?)\s*(억|천만|백만|십만|만|천)?\s*(엔|달러|불|유로|위안|파운드|원)/.exec(t);
  if (!a) return null;
  const o = a[2] ? pn(a[2]) : null, r = P(a[1]);
  if (!r) return null;
  const l = o ? ue(r, o) : r, s = Xt(a[3]);
  if (!s) return null;
  const i = s !== "KRW" ? "KRW" : Xt(c_(t));
  if (!i || i === s) return null;
  const u = _n(n, l, s, i);
  return u ? {
    ok: !0,
    explain: `${re(l, l.s, !0)} ${s} → ${i} · ${u.notice}`,
    value: `${re(u.value, 2, !0)} ${i}`
  } : null;
}
function c_(t) {
  const n = /(?:을|를|으로|로)\s*(엔|달러|불|유로|위안|파운드|원)/.exec(t);
  return n ? n[1] : "원";
}
const i_ = {
  억: "100000000",
  천만: "10000000",
  백만: "1000000",
  십만: "100000",
  만: "10000",
  천: "1000",
  백: "100"
};
function pn(t) {
  var n;
  return (n = P(i_[t])) != null ? n : gt(1);
}
const u_ = /((?:[\d,]+(?:\.\d+)?\s*(?:억|천만|백만|십만|만|천|백)\s*)+(?:[\d,]+(?:\.\d+)?)?)/g, m_ = /([\d,]+(?:\.\d+)?)\s*(억|천만|백만|십만|만|천|백)?/g;
function d_(t) {
  return t.replace(u_, (n) => {
    let a = P("0"), o = !1;
    for (const r of n.matchAll(m_)) {
      const l = P(r[1]);
      l && (o = !0, a = Ve(a, r[2] ? ue(l, pn(r[2])) : l));
    }
    return o ? re(a, a.s) : n;
  });
}
const __ = /원화|원|엔|씩|개월|개|명|건/g;
function p_(t) {
  return d_(t).replace(/(\d),(?=\d)/g, "$1").replace(/[×xX]/g, "*").replace(/÷/g, "/").replace(/더하기|플러스/g, "+").replace(/빼기|마이너스/g, "-").replace(/곱하기/g, "*").replace(/나누기/g, "/").replace(__, "").replace(/([\d.]+)\s*의\s*([\d.]+)\s*%/g, "($1*($2/100))").replace(/([\d.]+)\s*([+-])\s*([\d.]+)\s*%/g, "(($1)*(1$2$3/100))").trim();
}
const f_ = /[+＋]?\s*(부가세|소비세|消費税)\s*(?:([\d.]+)\s*%)?\s*(가산|포함|税込|税抜)?\s*$/;
function b_(t, n, a) {
  const o = P("1"), r = re(ue(n, gt(100)), 0);
  if (a === "add")
    return {
      value: ye(ue(t, Ve(o, n)), 0, "half"),
      explain: `消費税 ${r}% 가산(税抜 기준)`
    };
  const l = Se(ue(t, n), Ve(o, n));
  return {
    value: l ? ye(l, 0, "down") : t,
    explain: `消費税 ${r}% 역산(税込 기준 · 1円 미만 切捨て)`
  };
}
function h_(t, n) {
  var i;
  const a = t.trim();
  if (!a) return { ok: !1, supported: Ye };
  const o = t_(a, n.today), r = n_(o), l = o_(o, r);
  if (l) return l;
  const s = l_(o, r);
  if (s) return s;
  const c = s_(o, (i = n.rates) != null ? i : []);
  return c || E_(o, n);
}
function E_(t, n) {
  var u, d;
  const a = f_.exec(t), o = a ? t.slice(0, a.index) : t, r = p_(o);
  if (!r) return { ok: !1, supported: Ye };
  const l = Qd(r);
  if (!l.ok)
    return { ok: !1, supported: Ye };
  if (!a)
    return { ok: !0, explain: r, value: Wt(l.value), expr: r };
  const s = (d = (u = y_(a[2])) != null ? u : n.taxRate) != null ? d : null;
  if (!s)
    return {
      ok: !1,
      supported: ["소비세율을 아직 받지 못했습니다 — 세율(a_fa_param)을 읽어 오면 계산합니다", ...Ye]
    };
  const c = a[3] === "가산" || a[3] === "税抜" ? "add" : "extract", i = b_(l.value, s, c);
  return {
    ok: !0,
    explain: `${r} · ${i.explain}`,
    value: Wt(i.value),
    expr: r
  };
}
function y_(t) {
  var a;
  if (!t) return null;
  const n = P(t);
  return n && (a = Se(n, gt(100))) != null ? a : null;
}
function Wt(t) {
  const n = ye(t, 2, "half"), a = ye(n, 0, "down");
  return yt(n, a).u === BigInt(0) ? re(n, 0, !0) : re(n, 2, !0);
}
const oe = {
  area: {
    label: "넓이",
    base: "㎡",
    units: [
      { key: "m2", label: "㎡", factor: "1" },
      { key: "are", label: "아르", factor: "100" },
      { key: "ha", label: "헥타르", factor: "10000" },
      { key: "km2", label: "㎢", factor: "1000000" },
      { key: "pyeong", label: "평", factor: "3.305785" },
      { key: "ft2", label: "ft²", factor: "0.09290304" },
      { key: "yd2", label: "yd²", factor: "0.83612736" },
      { key: "acre", label: "에이커", factor: "4046.8564224" }
    ]
  },
  mass: {
    label: "중량·질량",
    base: "g",
    units: [
      { key: "mg", label: "mg", factor: "0.001" },
      { key: "g", label: "g", factor: "1" },
      { key: "kg", label: "kg", factor: "1000" },
      { key: "t", label: "t", factor: "1000000" },
      { key: "don", label: "돈", factor: "3.75" },
      { key: "geun", label: "근", factor: "600" },
      { key: "oz", label: "oz", factor: "28.349523125" },
      { key: "lb", label: "lb", factor: "453.59237" }
    ]
  },
  length: {
    label: "길이",
    base: "m",
    units: [
      { key: "mm", label: "mm", factor: "0.001" },
      { key: "cm", label: "cm", factor: "0.01" },
      { key: "m", label: "m", factor: "1" },
      { key: "km", label: "km", factor: "1000" },
      { key: "in", label: "in", factor: "0.0254" },
      { key: "ft", label: "ft", factor: "0.3048" },
      { key: "yd", label: "yd", factor: "0.9144" },
      { key: "mile", label: "mile", factor: "1609.344" },
      { key: "shaku", label: "자(尺)", factor: "0.30303" }
    ]
  }
};
function Gt(t, n) {
  const a = oe[t].units.find((r) => r.key === n);
  if (!a) return null;
  const o = P(a.factor);
  if (!o) throw new Error(`단위 환산표가 깨졌습니다 — ${a.key}`);
  return o;
}
function g_(t, n, a, o, r = 4, l = "half") {
  const s = Gt(t, n), c = Gt(t, a);
  if (!s || !c) return null;
  const i = Se(ue(o, s), c);
  return i ? ye(i, r, l) : null;
}
const v_ = [0, 1, 2, 3, 4, 6], k_ = [
  { key: "text", label: "AI 텍스트계산" },
  { key: "general", label: "일반계산" },
  { key: "date", label: "날짜계산" },
  { key: "unit", label: "단위계산" },
  { key: "fx", label: "환율계산" }
];
function N_(t) {
  const { tab: n, onTab: a, seed: o, onClose: r, history: l, onHistory: s } = t, [c, i] = y(() => o == null ? [Ue()] : [{ sign: "+", text: re(L_(o), 0, !0) }]), [u, d] = y(0), [_, p] = y(0), [b, f] = y("half"), m = F(null);
  K(() => {
    const v = (w) => {
      w.key === "Escape" && (w.preventDefault(), r());
    };
    return document.addEventListener("keydown", v), () => document.removeEventListener("keydown", v);
  }, [r]), K(() => {
    var v, w;
    (w = (v = m.current) == null ? void 0 : v.querySelector("[data-autofocus]")) == null || w.focus();
  }, [n]);
  const h = (v) => {
    const w = [...c.filter((E) => E.text !== ""), { sign: "+", text: v }, Ue()];
    i(w), d(w.length - 1), a("general");
  };
  return /* @__PURE__ */ e.createElement("div", { className: "bical-overlay", role: "presentation" }, /* @__PURE__ */ e.createElement("div", { className: "bical-modal", role: "dialog", "aria-modal": "true", "aria-label": "계산기", ref: m }, /* @__PURE__ */ e.createElement("div", { className: "bical-head" }, /* @__PURE__ */ e.createElement("span", { className: "bical-title" }, "계산기"), /* @__PURE__ */ e.createElement("span", { className: "bical-hint" }, "장부에 쓰지 않습니다 — 복사·일반계산 추가로만 내보냅니다"), /* @__PURE__ */ e.createElement("button", { type: "button", className: "bical-x", "aria-label": "닫기", onClick: r }, "✕")), /* @__PURE__ */ e.createElement("div", { className: "bical-tabs", role: "tablist" }, k_.map((v) => /* @__PURE__ */ e.createElement(
    "button",
    {
      key: v.key,
      type: "button",
      role: "tab",
      className: "bical-tab",
      "aria-selected": v.key === n,
      onClick: () => a(v.key)
    },
    v.label
  ))), /* @__PURE__ */ e.createElement("div", { className: "bical-body" }, n === "text" && /* @__PURE__ */ e.createElement(x_, { history: l, onHistory: s, onPush: h }), n === "general" && /* @__PURE__ */ e.createElement(
    Yd,
    {
      lines: c,
      onLines: i,
      active: u,
      onActive: d,
      digits: _,
      onDigits: p,
      mode: b,
      onMode: f
    }
  ), n === "date" && /* @__PURE__ */ e.createElement(C_, null), n === "unit" && /* @__PURE__ */ e.createElement(B_, null), n === "fx" && /* @__PURE__ */ e.createElement(S_, null)), /* @__PURE__ */ e.createElement("div", { className: "bical-foot" }, /* @__PURE__ */ e.createElement("button", { type: "button", className: "bical-btn", onClick: r }, "닫기"))));
}
const w_ = [
  "1,200만 + 350만 × 2",
  "3,000,000의 15%",
  "2026-01-01부터 2026-03-31까지 며칠",
  "2026-07-17부터 90일 후",
  "150만엔을 원화로",
  "오늘부터 10일 후"
], $_ = 20;
function x_({ history: t, onHistory: n, onPush: a }) {
  var f;
  const [o, r] = y(""), [l, s] = y(null), [c, i] = y(!1), [u, d] = y(!1), _ = F(!1), p = Ne(kt, []), b = (m) => {
    r(m), d(!1);
    const h = h_(m, { today: p, rates: Ge, taxRate: null });
    s(h), m.trim() && n([m, ...t.filter((v) => v !== m)].slice(0, $_));
  };
  return /* @__PURE__ */ e.createElement("div", null, /* @__PURE__ */ e.createElement(
    "textarea",
    {
      className: "bical-textarea",
      "data-autofocus": !0,
      value: o,
      placeholder: "문장으로 물어보세요 — Enter 계산 · Shift+Enter 줄바꿈",
      onChange: (m) => r(m.target.value),
      onCompositionStart: () => {
        _.current = !0;
      },
      onCompositionEnd: () => {
        _.current = !1;
      },
      onKeyDown: (m) => {
        m.key === "Enter" && !m.shiftKey && !_.current && !m.nativeEvent.isComposing && (m.preventDefault(), b(o));
      }
    }
  ), /* @__PURE__ */ e.createElement("div", { className: "bical-chips" }, w_.map((m) => /* @__PURE__ */ e.createElement("button", { key: m, type: "button", className: "bical-chip", onClick: () => b(m) }, m))), l && (l.ok ? /* @__PURE__ */ e.createElement("div", { className: "bical-result" }, /* @__PURE__ */ e.createElement("div", { className: "bical-explain" }, l.explain), /* @__PURE__ */ e.createElement("div", { className: "bical-value" }, l.value), /* @__PURE__ */ e.createElement("div", { className: "bical-chips" }, /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: "bical-btn",
      onClick: () => {
        var m;
        (m = navigator.clipboard) == null || m.writeText(l.value).then(
          () => d(!0),
          () => d(!1)
        );
      }
    },
    u ? "복사함" : "결과복사"
  ), /* @__PURE__ */ e.createElement("button", { type: "button", className: "bical-btn", onClick: () => a(l.value) }, "일반계산에 추가"))) : /* @__PURE__ */ e.createElement("div", { className: "bical-result bical-notice" }, /* @__PURE__ */ e.createElement("div", { className: "bical-explain" }, "읽지 못했습니다 — 지원하는 형식입니다"), /* @__PURE__ */ e.createElement("ul", { style: { margin: "4px 0 0", paddingLeft: 16 } }, ((f = l.supported) != null ? f : Ye).map((m) => /* @__PURE__ */ e.createElement("li", { key: m }, m))))), t.length > 0 && /* @__PURE__ */ e.createElement("div", { className: "bical-log" }, /* @__PURE__ */ e.createElement("button", { type: "button", onClick: () => i((m) => !m) }, "기록 ", t.length, "건 ", c ? "접기" : "펼치기"), c && /* @__PURE__ */ e.createElement("ol", null, t.map((m) => /* @__PURE__ */ e.createElement("li", { key: m }, /* @__PURE__ */ e.createElement("button", { type: "button", onClick: () => b(m) }, m))))), /* @__PURE__ */ e.createElement("div", { className: "bical-sub", style: { marginTop: 8 } }, "기록은 이 세션에만 남고 저장하지 않습니다."));
}
function C_() {
  const t = Ne(kt, []), [n, a] = y(ee(t)), [o, r] = y(ee(t)), [l, s] = y("exclude-first"), c = pt(n), i = pt(o), u = c && i ? mn(c, i, l) : null;
  return /* @__PURE__ */ e.createElement("div", null, /* @__PURE__ */ e.createElement("div", { className: "bical-row" }, /* @__PURE__ */ e.createElement("span", { className: "bical-label" }, "계산 방식"), /* @__PURE__ */ e.createElement("select", { className: "bical-select", value: l, onChange: (d) => s(d.target.value) }, /* @__PURE__ */ e.createElement("option", { value: "exclude-first" }, "초일불산입 말일산입"), /* @__PURE__ */ e.createElement("option", { value: "include-first" }, "초일산입 말일산입"))), /* @__PURE__ */ e.createElement("div", { className: "bical-row" }, /* @__PURE__ */ e.createElement("span", { className: "bical-label" }, "기간"), /* @__PURE__ */ e.createElement("input", { className: "bical-input", type: "date", "data-autofocus": !0, value: n, onChange: (d) => a(d.target.value) }), /* @__PURE__ */ e.createElement("span", null, "~"), /* @__PURE__ */ e.createElement("input", { className: "bical-input", type: "date", value: o, onChange: (d) => r(d.target.value) })), u ? /* @__PURE__ */ e.createElement("div", { className: "bical-result" }, /* @__PURE__ */ e.createElement("div", { className: "bical-explain" }, ee(c), "(", ft(c), ") ~ ", ee(i), "(", ft(i), ")", u.swapped ? " · 역순 입력" : ""), /* @__PURE__ */ e.createElement("div", { className: "bical-value" }, u.days.toLocaleString(), "일"), /* @__PURE__ */ e.createElement("div", { className: "bical-sub" }, "차이(년, 월, 일) — ", u.y, "년 ", u.m, "개월 ", u.d, "일")) : /* @__PURE__ */ e.createElement("div", { className: "bical-result bical-notice" }, "날짜를 두 개 모두 입력하세요."));
}
function B_() {
  const [t, n] = y("area"), [a, o] = y(oe.area.units[0].key), [r, l] = y(oe.area.units[4].key), [s, c] = y(""), [i, u] = y(4), [d, _] = y("half"), p = (m) => {
    n(m), o(oe[m].units[0].key), l(oe[m].units[1].key), c("");
  }, b = P(s), f = b ? g_(t, a, r, b, i, d) : null;
  return /* @__PURE__ */ e.createElement("div", null, /* @__PURE__ */ e.createElement("div", { className: "bical-row" }, /* @__PURE__ */ e.createElement("span", { className: "bical-label" }, "분류"), /* @__PURE__ */ e.createElement("select", { className: "bical-select", value: t, onChange: (m) => p(m.target.value) }, Object.keys(oe).map((m) => /* @__PURE__ */ e.createElement("option", { key: m, value: m }, oe[m].label))), /* @__PURE__ */ e.createElement("span", { className: "bical-sub" }, "기준 ", oe[t].base)), /* @__PURE__ */ e.createElement("div", { className: "bical-row" }, /* @__PURE__ */ e.createElement("span", { className: "bical-label" }, "값"), /* @__PURE__ */ e.createElement(
    "input",
    {
      className: "bical-input bical-num",
      "data-autofocus": !0,
      inputMode: "decimal",
      value: s,
      onChange: (m) => c(m.target.value.replace(/[^\d.-]/g, ""))
    }
  ), /* @__PURE__ */ e.createElement("select", { className: "bical-select", value: a, onChange: (m) => o(m.target.value) }, oe[t].units.map((m) => /* @__PURE__ */ e.createElement("option", { key: m.key, value: m.key }, m.label))), /* @__PURE__ */ e.createElement("span", null, "→"), /* @__PURE__ */ e.createElement("select", { className: "bical-select", value: r, onChange: (m) => l(m.target.value) }, oe[t].units.map((m) => /* @__PURE__ */ e.createElement("option", { key: m.key, value: m.key }, m.label)))), /* @__PURE__ */ e.createElement("div", { className: "bical-row" }, /* @__PURE__ */ e.createElement("span", { className: "bical-label" }, "자리수"), /* @__PURE__ */ e.createElement("select", { className: "bical-select", value: i, onChange: (m) => u(Number(m.target.value)) }, v_.map((m) => /* @__PURE__ */ e.createElement("option", { key: m, value: m }, m))), /* @__PURE__ */ e.createElement("select", { className: "bical-select", value: d, onChange: (m) => _(m.target.value) }, /* @__PURE__ */ e.createElement("option", { value: "half" }, "반올림"), /* @__PURE__ */ e.createElement("option", { value: "up" }, "올림"), /* @__PURE__ */ e.createElement("option", { value: "down" }, "버림"))), /* @__PURE__ */ e.createElement("div", { className: "bical-result" }, /* @__PURE__ */ e.createElement("div", { className: "bical-explain" }, Kt(t, a), " → ", Kt(t, r), " · 기준단위 1단계 환산"), /* @__PURE__ */ e.createElement("div", { className: "bical-value" }, f ? re(f, i, !0) : "—")));
}
function Kt(t, n) {
  var a, o;
  return (o = (a = oe[t].units.find((r) => r.key === n)) == null ? void 0 : a.label) != null ? o : n;
}
function S_() {
  const t = Ne(kt, []), [n, a] = y(ee(t)), [o, r] = y("JPY"), [l, s] = y("KRW"), [c, i] = y(""), u = P(c), d = u ? _n(Ge, u, o, l) : null, _ = bt(Ge, o);
  return /* @__PURE__ */ e.createElement("div", null, /* @__PURE__ */ e.createElement("div", { className: "bical-row" }, /* @__PURE__ */ e.createElement("span", { className: "bical-label" }, "기준일자"), /* @__PURE__ */ e.createElement("input", { className: "bical-input", type: "date", value: n, onChange: (p) => a(p.target.value) })), /* @__PURE__ */ e.createElement("div", { className: "bical-row" }, /* @__PURE__ */ e.createElement("span", { className: "bical-label" }, "금액"), /* @__PURE__ */ e.createElement(
    "input",
    {
      className: "bical-input bical-num",
      "data-autofocus": !0,
      inputMode: "decimal",
      value: c,
      onChange: (p) => i(p.target.value.replace(/[^\d.-]/g, ""))
    }
  ), /* @__PURE__ */ e.createElement("select", { className: "bical-select", value: o, onChange: (p) => r(p.target.value) }, Ge.map((p) => /* @__PURE__ */ e.createElement("option", { key: p.code, value: p.code }, p.code, " (", p.label, ")"))), /* @__PURE__ */ e.createElement("span", null, "→"), /* @__PURE__ */ e.createElement("select", { className: "bical-select", value: l, onChange: (p) => s(p.target.value) }, Ge.map((p) => /* @__PURE__ */ e.createElement("option", { key: p.code, value: p.code }, p.code, " (", p.label, ")")))), /* @__PURE__ */ e.createElement("div", { className: "bical-result" }, /* @__PURE__ */ e.createElement("div", { className: "bical-explain" }, _ ? dn(_) : ""), /* @__PURE__ */ e.createElement("div", { className: "bical-value" }, d ? re(d.value, 2, !0) : "—")), /* @__PURE__ */ e.createElement("div", { className: "bical-result bical-notice" }, /* @__PURE__ */ e.createElement("b", null, "샘플 고시입니다 — 원천 미결."), " 토·일·공휴일 데이터가 없고, 기준통화·전신환 구분(TTM/TTS/TTB)도 정해지지 않았습니다. 신고·장부 목적에 쓰지 마세요."));
}
function kt() {
  const t = /* @__PURE__ */ new Date();
  return { y: t.getFullYear(), m: t.getMonth() + 1, d: t.getDate() };
}
function L_(t) {
  var n;
  return ye((n = P(String(t))) != null ? n : P("0"), 0, "half");
}
const fn = vn(null);
function nf({ children: t }) {
  const [n, a] = y(!1), [o, r] = y("text"), [l, s] = y(null), [c, i] = y([]), [u, d] = y(0), _ = Ne(() => ({
    open: (p) => {
      var b, f;
      r((b = p == null ? void 0 : p.tab) != null ? b : "text"), s((f = p == null ? void 0 : p.seed) != null ? f : null), d((m) => m + 1), a(!0);
    },
    close: () => a(!1)
  }), []);
  return /* @__PURE__ */ e.createElement(fn.Provider, { value: _ }, t, n && /* @__PURE__ */ e.createElement(
    N_,
    {
      key: u,
      tab: o,
      onTab: r,
      seed: l,
      onClose: _.close,
      history: c,
      onHistory: i
    }
  ));
}
function af() {
  var t;
  return (t = kn(fn)) != null ? t : { open: () => {
  }, close: () => {
  } };
}
class of extends Yt {
  constructor() {
    super(...arguments), this.rootRef = Nn(), this.resizeSensor = null;
  }
  componentDidMount() {
    this.rootRef.current && (this.resizeSensor = new nn(this.rootRef.current, this.props.onResize));
  }
  componentWillUnmount() {
    this.resizeSensor && (this.resizeSensor.detach(), this.resizeSensor = null);
  }
  render() {
    const { onResize: n, children: a, ...o } = this.props;
    return /* @__PURE__ */ e.createElement("div", { ref: this.rootRef, ...o }, a);
  }
}
export {
  dp as AXActionCard,
  X_ as AXAiIconBadge,
  Z_ as AXAiSuggestionBanner,
  tn as AXAvatar,
  O_ as AXAvatarStack,
  W_ as AXBadge,
  _p as AXBreadcrumb,
  lp as AXButton,
  q_ as AXCardPanel,
  G_ as AXCommentRow,
  R_ as AXCommentThread,
  op as AXDataTable,
  z_ as AXDivider,
  fp as AXDrawer,
  bp as AXDropdownMenu,
  Q_ as AXEmptyState,
  Pp as AXErpBanner,
  _t as AXErpButton,
  N_ as AXErpCalculatorModal,
  nf as AXErpCalculatorProvider,
  Fp as AXErpCard,
  Dp as AXErpCodePicker,
  tf as AXErpCsvButton,
  Tt as AXErpDatePicker,
  qp as AXErpDateRange,
  Dm as AXErpError,
  Si as AXErpField,
  Qp as AXErpFileDrop,
  Zp as AXErpFilterBand,
  Up as AXErpFormRow,
  Yp as AXErpFormSection,
  Bp as AXErpGisuField,
  vp as AXErpGlyph,
  Sp as AXErpGrid,
  jp as AXErpGridStatus,
  Cp as AXErpHint,
  kp as AXErpIcon,
  gp as AXErpIconButton,
  Ym as AXErpModal,
  zp as AXErpMoneyInput,
  Im as AXErpMsg,
  Op as AXErpNote,
  Ep as AXErpPage,
  xp as AXErpPill,
  Vp as AXErpReadonly,
  $p as AXErpReadout,
  wp as AXErpSearchBar,
  Wp as AXErpStateBadge,
  Mp as AXErpSummaryCard,
  Np as AXErpTabs,
  yp as AXErpTitleBar,
  Jp as AXErpToggle,
  Xp as AXErpVerify,
  ep as AXExpandableSummary,
  K_ as AXFileChip,
  ko as AXFileTypeIcon,
  sp as AXIconButton,
  rp as AXKeyValueGrid,
  H_ as AXKeyValueRow,
  U_ as AXListRow,
  hp as AXModal,
  P_ as AXPanelHeader,
  Y_ as AXPersonRow,
  tp as AXProgressBar,
  V_ as AXRankingRow,
  cp as AXSearchInput,
  ip as AXSegmentedControl,
  J_ as AXStatusBadge,
  np as AXStepProgress,
  up as AXTagChip,
  mp as AXToggleSwitch,
  pp as AXTreeItem,
  ap as AXTypingDots,
  Rm as AX_ERP_DIRTY_MESSAGE,
  Vt as GW_ORIGIN,
  an as OBTPortal,
  of as OBTResizeContainer,
  nn as OBTResizeSensor,
  Je as REFRESH_KEY,
  ut as SESSION_EXPIRED_EVENT,
  ht as TOKEN_KEY,
  on as amDigits,
  Em as amNumber,
  Ze as authorizedFetch,
  lm as axErpCodeLabel,
  ef as axErpDownload,
  Rd as axErpFileName,
  Li as axErpGisuLabel,
  Hp as axErpHttpMessage,
  Tp as axErpRangeValid,
  rn as axErpSaveBlob,
  qd as axErpSaveCsv,
  Td as axErpTableToCsv,
  Bn as clearTokens,
  F_ as colors,
  M_ as configureAuth,
  I_ as configureComments,
  Et as decodeClaims,
  hm as fmtAm,
  Rp as fmtDt,
  Fn as getFreshToken,
  xn as getStoredToken,
  $n as isExpired,
  Zt as isRefreshExpired,
  Mn as isReply,
  Ap as measureMoneyMetrics,
  Lp as moneyColWidth,
  su as moneyColWidthForDigits,
  Ke as notifySessionExpired,
  D_ as onSessionExpired,
  en as refreshTokens,
  Cn as saveTokens,
  Ln as startRefreshExpiryWatch,
  Qt as stopRefreshExpiryWatch,
  bm as toHalfWidth,
  Ip as todayLocal,
  af as useAXErpCalculator,
  Kp as useAXErpConfirm,
  Tm as useAXErpDirtyGuard,
  Gp as useAXErpNotice,
  T_ as useCommentCounts,
  zn as useComments
};
